/* Chelsea and Rachel Co. 2024 */




class CnrVariableStore {
  static setValues(textObject) {
    
    if (window._CnrVariableStoreValues) {
      window._CnrVariableStoreValues = {...window._CnrVariableStoreValues,...textObject}
    } else {
      window._CnrVariableStoreValues = textObject;  
    }
  }
  static booleanFor(key,defaultValue) {
    
    return ["true","yes"].includes(CnrVariableStore.textFor(key,defaultValue).toLowerCase())
  }
  static intFor(key,defaultValue) {
    return parseInt(CnrVariableStore.textFor(key,defaultValue))
  }
  static textFor(key,defaultValue) {
    
    if (window._CnrVariableStoreValues[key]) {
      return window._CnrVariableStoreValues[key]
    } else {
      if (defaultValue) {
        return defaultValue;
      } else {
        return `missing text for ${key}`  
      }
    }
  }
}
Object.defineProperty(String.prototype, 'capitalize', {
  value: function() {
    return this.charAt(0).toUpperCase() + this.slice(1);
  },
  enumerable: false
});
Object.defineProperty(String.prototype, 'depluralize', {
  value: function() {
    let lastChar = this.substring(this.length-1)
    if (lastChar=="s" || lastChar=="S") {
      return this.substring(0,this.length-1)
    }
    return this
  },
  enumerable: false
});

class HasUUID {
  contructor(options) {
    this.uuid = crypto.randomUUID()
    
  }
  getThisElement() {
    return document.querySelector(`[data-uuid="${this.uuid}"]`)
  }
}

class CnR  {
  api_version = "2024-10";
  keyname = "subscriptions-2024-02";

  static isMobile() {
    return window.innerWidth<=911;
  }

 constructor(opts={}) {

      this.config = {...this.defaults(),...opts};
      this.errors=[];
      this.requires().forEach(field=>{
        if (!field in this.config) {
          this.errors.push(`Missing Required config field: ${field}`)
        }
      });
      if (this.errors.length>0) {
        throw new Error(this.errors.join("\n"));
      }
  }
  static dispatchEvent(name,detail=null) {
    document.dispatchEvent(
      new CustomEvent(
        name,
        {"bubbles":true,"detail":detail}
      )
    )
  }
  static scrollToTarget(selector) {
    var element = document.querySelector(selector);
    var headerOffset = 0;
    var elementPosition = element.getBoundingClientRect().top;
    var offsetPosition = elementPosition + window.pageYOffset - headerOffset;
      
    window.scrollTo({
          top: offsetPosition,
          behavior: "smooth"
      });   
  }

  requires() {
    return []
  }
  defaults() {
    return {
      api_version:"2023-10",

      keyname:"subscriptions-2024-02",
      siteRoot:'',

    };
  }
  fetch(url,config) {
    if (this.config.fetch_function) {
      return pure_fetch(url,config)
    } else {
      return fetch(url,config)
    }
  }
  /* shopify cart functions */

  siteUrl(path) {
    if (this.config.siteRoot) {
        return `${this.config.siteRoot}${path}`
    }
    return path
  }
  async getCart(url=this.siteUrl("/cart.js"),extended=false,callback=()=>{}) {
      let cart = {};
      return this.fetch(url)
    .then(res=>(extended)?res.text():res.json());
  }
  async request(url) {
      return this.fetch(this.siteUrl(ur)).then(text=>response.text())
  }
  async updateCart(payload) {
    return this.fetch(this.siteUrl(`/cart/update.js`), {

      method: 'POST',
      credentials: 'same-origin',
      headers: {
        'Content-Type': 'application/json',
        'X-Requested-With': 'xmlhttprequest'
      },
      body: JSON.stringify(payload)
    }).then((response) => response.json());
 }
  async removeItemFromCart(key) {
      return this.changeCart({
          id:key,
          quantity:0
        })
  }
  async updateItemCount(key,quantity) {
    return this.changeCart({
      id:key,
      quantity:parseInt(quantity)
    })
  }
  async changeCart(payload) {

      return this.fetch(this.siteUrl(`/cart/change.js`), {

          method: 'POST',
          credentials: 'same-origin',
          headers: {
            'Content-Type': 'application/json',
            'X-Requested-With': 'xmlhttprequest'
          },
          body: JSON.stringify(payload)
        }).then((response) => response.json());
   }
   async addToCart(payload) {
      let config = {
          method: 'POST',
          credentials: 'include',
          headers: {
              'Content-Type': 'application/json',
          },
          body: JSON.stringify(payload),
      }

      return this.fetch(this.siteUrl("/cart/add.js"),config)
          .then((response) => response.json())
   }


   static setupDawnProductForm(form) {
      form.querySelector("button").addEventListener("click",event=>{
         event.preventDefault();
         event.stopPropagation();
         new CnR().addToDawnCart(form).then(response=>{

       });
      });
    }
    async addToDawnCart(form) {

       let cart = document.querySelector("cart-drawer");
       const formData = new FormData();
       formData.append('product-id',form.dataset.productId);
       formData.append("id",form.querySelector('[name="id"]').value)
       formData.append("quantity",1);
       try {

         formData.append("selling_plan",form.querySelector('[name="selling_plan"]').value);
       } catch(e) {}

       formData.append('sections',cart.getSectionsToRender().map((section) => section.id));
       formData.append('sections_url',form.dataset.url);
       formData.append('form_type','product');

       return this.fetch(this.siteUrl("/cart/add"),{

           method: 'POST',
           headers: {
               "Accept":"application/javascript",
               "X-Requested-With":"XMLHttpRequest"
           },
           body: formData,form
       })
           .then((response) => response.json())
           .then(json=>{

             if (json.status) {
               CnRModal.show(json.description);
             } else {
               cart.renderContents(json);
               cart.classList.remove("is-empty")
             }
             return json;
       });
    }

      static openDawnCart() {
        let cartItems = document.querySelector("cart-drawer-items")
        fetch(`/cart?section_id=cart-drawer`)
          .then((response) => response.text())
          .then((responseText) => {
            
            const html = new DOMParser().parseFromString(responseText, 'text/html');
            const selectors = ['cart-drawer-items', '.cart-drawer__footer'];
            for (const selector of selectors) {
              const targetElement = document.querySelector(selector);
              const sourceElement = html.querySelector(selector);
             
              if (targetElement && sourceElement) {
                targetElement.replaceWith(sourceElement);
              }
            }
            let drawer = document.querySelector("cart-drawer");
            let isemptyDiv = drawer.querySelector(".drawer__inner-empty");
            if (isemptyDiv) {
              isemptyDiv.parentNode.removeChild(isemptyDiv)
            }
            
            drawer.querySelector(".cart__checkout-button.button").disabled=false;
            drawer.open()
            drawer.classList.remove("is-empty")
            
          })
        
      }

   /* graphql functions */
   async graphql(query,params) {
      return fetch(this.siteUrl(`/api/${this.api_version}/graphql.json`),{

          method:"POST",
          headers:{
            "content-type":"application/json",
            "X-Shopify-Storefront-Access-Token":this.config.graphql_token
            },
            body:JSON.stringify({query:query,variables:params})
          })
          .then(response=>response.json())
  }
  graphql_sync(query,params) {
      let ajax = new XMLHttpRequest();
      ajax.headers = {
          "content-type":"application/json",
          "X-Shopify-Storefront-Access-Token":this.config.graphql_token
      }

      ajax.open("POST",this.siteUrl(`/api/${this.api_version}/graphql.json`),false)

      ajax.setRequestHeader("Content-Type", "application/json");
      ajax.setRequestHeader("X-Shopify-Storefront-Access-Token", storefront_token);
      ajax.send(JSON.stringify({query:query,params:params}));
      return JSON.parse(ajax.responseText);
  }
  gid2id(gid) {
    return parseInt(gid.split("/").pop())
  }
  collapse_query(object) {
    if (object==null) {
        return object;
    }
    switch(object.constructor.name) {
    case "Array":
        return object.map(item=>this.collapse_query(item));
        break;
        case "Object":
            let ret = {};
            Object.keys(object).forEach(key=>{
                if (object[key]==null) {
                    ret[key] = null;
                    return;
                }
                if (object[key].reference) {
                    ret[key] = this.collapse_query(object[key].reference)
                    return;


                }
                if (object[key].references) {
                    let all = [];
                    object[key].references.nodes.forEach(ref=>{
                        let crv = {};
                        if (ref.fields) {
                          ref.fields.forEach(field=>{
                            crv[field.key]=this.collapse_query(field.value)
                          })  
                        } else {
                          
                          Object.keys(ref).forEach(field=>{
                            
                            if (ref[field]) {
                              if (ref[field].value) {
                                crv[field]=this.collapse_query(ref[field].value)
                              } else if (typeof ref[field] === "string") {
                                crv[field] = ref[field]
                              } else {
                                let newHash = {}
                                
                                Object.keys(ref[field]).forEach(key=>{
                                  newHash[key] = this.collapse_query(ref[field][key])
                                });
                                crv[field] = newHash
                              }
                              
                              
                            } else {
                              crv[field] = null
                            }
                            
                          })
                        }
                        
                        all.push(crv)
                    })
                    object[key] = all;


                }
                if (object[key].type && object[key].type=="json") {
                  object[key] = JSON.parse(object[key ])
                }
                if (object[key].nodes && object[key].nodes.constructor.name=="Array") {
                    ret[key] = this.collapse_query(object[key].nodes);
                } else {
                    ret[key] = this.collapse_query(object[key])
                }
            });
            return ret
            break;
        default:
            if (object) {
                return object;
            }


            break;
    }
}

   css() {
      return '';
   }
   inject_css() {
      let css = this.css();
      if (css.length>0) {
          let style = document.createElement("style");
          style.id=this.constructor.name.toLowerCase();
          style.textContent = this.css();
          document.querySelector("head").appendChild(style);
      }


   }
   

}
class CnrStorefront extends CnR {
  requires() {
    return ["graphql_token"]
  }
}
/* src/cnr-modal/cnr-modal.js  */
class CnRModal extends CnR {
    static setDimensions(modal) {
      if (modal) {
          modal.style.width = `${window.innerWidth}px`;
          modal.style.height = `${window.innerHeight}px`;
        window.addEventListener("resize",event=>{
          
          CnRModal.setDimensions(modal);
          },
          {once:true}                      
        )
      }
    }
    static show(content,closeable=true) {
        let modal = document.querySelector(".cnr-modal");
        if (!modal) {
            modal = document.createElement("DIV");
            modal.classList.add("cnr-modal");
            document.querySelector("body").appendChild(modal);
        }
        //CnRModal.setDimensions(modal);
        modal.style.width = `${window.innerWidth}px`;
        modal.style.height = `${window.innerHeight}px`;
        
        modal.style.top = `${window.scrollY}px`
        modal.innerHTML = `
        <div class="modal-content">
            <span class="close">
                <svg xmlns="http://www.w3.org/2000/svg" width="18" height="18" viewBox="0 0 18 18" fill="none" role="presentation"><path d="M5.86123 14.1073L5.21766 14.1073L3.67204 12.5617L3.67204 11.9181L6.68057 8.90959L3.6521 5.88112L3.6521 5.23755L5.2376 3.65205L5.88117 3.65204L8.90964 6.68052L11.9182 3.67199L12.5617 3.67199L14.1074 5.21761L14.1074 5.86118L11.0988 8.86971L14.1273 11.8982L14.1273 12.5417L12.5418 14.1273H11.8982L8.86976 11.0988L5.86123 14.1073Z" fill="#af3939"></path></svg>
            </span>
            <div class="modal-text text-left color-foreword-primary body1">
                ${content}
            </div>
        </div>
        `;
        if (closeable){
          modal.querySelector(".close").style.display="block";
          modal.querySelector(".close").addEventListener("click",event=>{
              modal.classList.remove("active");
              modal.innerHTML = "";
              document.querySelector("body").classList.remove("stop-scrolling");

              CnR.dispatchEvent("cnr:modal:closed",null)

          });
          modal.addEventListener("click",event=>{
            if (event.target.classList.contains("cnr-modal")) {
                modal.classList.remove("active");
                modal.style.top = "0px";
                modal.innerHTML = "";
                document.querySelector("body").classList.remove("stop-scrolling");

                CnR.dispatchEvent("cnr:modal:closed",null)

            }
          })
        } else {
          modal.querySelector(".close").style.display="none";
        }
        document.querySelector("body").classList.add("stop-scrolling");
        modal.classList.add("active");
        CnR.dispatchEvent("cnr:modal:show",{});
        
        return modal;
    }
    static close() {
    let modal = document.querySelector(".cnr-modal");
    modal.classList.remove("active");
    modal.innerHTML = "";
    document.querySelector("body").classList.remove("stop-scrolling");
    CnR.dispatchEvent("cnr:modal:show",{});
    return modal
    }
}

/* src/cnr-quantity-field/cnr-quantity.js  */

class CnrSelect  extends HasUUID {
  defaults() {
    return {
      classList:[],
      options:[],
      includeSelectOption:false,
      id:"cnr-select"
    }
  }
  constructor(options) {
    super(options)
    this.uuid = crypto.randomUUID()
    this.config = {...this.defaults(),...options};
    this.value = this.config.value;
    document.addEventListener("cnr:formFields:rendered",event=>{
      this.setupEvents()
    });
  }
  render() {
    
    return `
      <select name="${this.config.name}" id="${this.config.id}" class="cnr-select ${this.config.classList.join(" ")}" data-uuid="${this.uuid}">
        ${this.config.includeSelectOption?'<option>Select</option>':''}
        ${this.config.options.map(option=>`<option value="${option.value}" ${this.value==option.value?' selected':''}>${option.label}</option>`).join("\n")}
      </select>
    `
  }
  getValue() {
    let thisElement = this.getThisElement();
    return thisElement.options[thisElement.selectedIndex].value
  }
  setValue(value) {
    this.value = value;
  }
  setupEvents() {
    this.getThisElement().addEventListener("change",event=>{
      
      this.value = this.getValue()
      CnR.dispatchEvent("cnr:formFields:valueChanged",{name:this.config.name,value:this.getValue(),object:this})
    })
  }
}


class CnrQuantity {
    defaults() {
        return {
            "min":1,
            "max":999999,
            "step":1,
            "value":1,
            dataset:{},
        }
    }
    constructor(options={}) {
        this.uuid = crypto.randomUUID()
        this.config = {...this.defaults(),...options};
    }
    dataset() {
        return Object.keys(this.config.dataset).map(k=>`data-${k}="${this.config.dataset[k]}"`).join(" ");
    }
    setdata(data) {
      this.config.dataset = {};
    }
    render() {
        return `
        <div class="cnr-quantity ${this.config.value>0?'active':''}" data-uuid="${this.uuid}">
            <div class="wrapper">
                <span class="minus" data-uuid="${this.uuid}">-</span>

                <label for="${this.uuid}">${this.config.value}</label>
                <input type="number" name="quantity" class="quantity-input" min=${this.config.min}" max="${this.config.max}" step="${this.config.step}" value="${this.config.value}" id="${this.uuid}" ${this.dataset()}/>

                <span class="plus" data-uuid="${this.uuid}">+</span>
            </div>
            <span class="extra">${this.extra()}</span>
        </div>
        `
    }

    root() {
      return document.querySelector(`[data-uuid="${this.uuid}"]`)
    }
    static setupEvents() {
        
        document.querySelectorAll(".cnr-quantity").forEach(quantity=>{
            
            let current = quantity.querySelector(".quantity-input");
            let label = quantity.querySelector("label")
            quantity.querySelector(".plus").addEventListener("click",event=>{

                if (current.disabled) { return;}
                if (parseInt(current.value)+1<=parseInt(current.max)) {
                    current.value = parseInt(current.value)+1;
                    label.textContent = current.value;

                    quantity.classList.add("active");
                    this.active = true;
                    let dataset = Object.assign({},current.dataset);
                    dataset.quantity=current.value;
                    CnR.dispatchEvent("cnr:quantity:changed",{dataset:dataset,value:current.value,field:current})

                }
            });
            quantity.querySelector(".minus").addEventListener("click",event=>{
                if (current.disabled) { return;}
                if (parseInt(current.value)-1>=parseInt(current.min)) {
                    current.value = parseInt(current.value)-1

                    label.textContent = current.value;
                    if (current.value<=parseInt(current.min)) {
                        quantity.classList.remove("active");
                    }
                    this.active = true;
                    let dataset = Object.assign({},current.dataset);
                    dataset.quantity=current.value;
                    CnR.dispatchEvent("cnr:quantity:changed",{dataset:dataset,value:current.value,field:current})

                }
            })
        })

    }
    extra() { return ''}
}
/* src/cnr-sorcistino/sorcistino.js  */
class Sorcistino extends CnR {
    defaults() {
        return {
            injection_point:".sorcistino-holder",
            zeroButtonBehavior: "hide",
            class:"sorcistino",
        }

    }
    constructor(options) {
        super(options)
        this.screens = [];
        this.screen = 0;
        this.data = {};
        this.screens_data = {}
        this.screenTitles = []
        this.root = document.querySelector(this.config.injection_point);
        this.load_data();
        this.uuid = crypto.randomUUID();

        document.addEventListener("sorcistino:screen:completed",event=>{
          
            this.processScreen(event.detail)
        })
    }
    processScreen(data) {

    }
    query() {
        return ``;
    }

    element(selector) {
      return this.root.querySelector(selector)
    }


    additionalVariantQuery() {
        return ``
    }
    additionalProductQuery() {
        return ``
    }
    productQuery() {
     return `
            query getProducts($id: ID!) {
                product(id:$id) {
                    id
                    variants(first:100) {
                        nodes {
                            id
                            availableForSale
                            
                            price {
                                amount
                            }
                            ${this.additionalVariantQuery()}
                        }
                    }
                    ${this.additionalProductQuery()}

                    sellingPlanGroups(first: 10) {

                        nodes {
                            appName
                            name
                            sellingPlans(first:250) {

                                nodes {

                                    recurringDeliveries
                                    id
                                    options {
                                        value
                                    }
                                    description
                                    priceAdjustments {
                                        adjustmentValue {
                                            ... on SellingPlanPercentagePriceAdjustment {
                                                percent: adjustmentPercentage
                                            }
                                            ... on SellingPlanFixedPriceAdjustment {
                                                amount: price {
                                                    amount
                                            }
                                        }
                                    }
                                }
                            }
                        }
                    }
                }
            }
        }`
    }

    addScreen(data,index) {
        this.screens.push(new SorcistinoScreen(this,data,index))
    }
    render(startingScreen=0) {
        this.root.innerHTML = `

            <div class="sorcistino-holder ${this.config.class} ${CnR.isMobile()?' mobile':''}" data-screen="${this.screen}">
                <div class="sorcistino-header">
                    <div class="title"></div>
                    ${this.renderHeader()}
                </div>
                <div class="content"></div>
                <div class="footer">${this.renderFooter()}</div>
            </div>
        `
        this.setupEvents();
        CnR.dispatchEvent("sorcistino:rendered",this)
        this.show(startingScreen)
    }
    renderProgress() {
      return `
      <div class="progress">
        <div class="progress-bar-wrapper js-progress-bar-wrapper">
          <div class="progress js-progress" style="width: 0%;"></div>
        </div>
      </div>
      `
    }
    renderPreNav() {
      return '';
    }
    renderNavButtons() {
      return `
      <div class="preNav">${this.renderPreNav()}</div>
      <div class="nav">
            <div class="sorcistino-nav-menu">
                <div class="sorcistino-nav-holder">
                    <button class="sorcistino-nav-button button cta grid-item-cta cta-foreward-lite-primary" data-screen-nav="back" ${this.canGoBack()?'':'disabled'}>Back</button>
                    ${this.screens[this.screen].extraButtons()}
                    <button class="sorcistino-nav-button button cta grid-item-cta cta-foreward-lite-primary" data-screen-nav="next" ${this.canGoForward()?'':'disabled'}>Next</button>
                </div>
            </div>
        </div>
        `
    }
    renderHeader() {
      return `
        ${this.renderProgress()}
        ${this.renderNavButtons()}
      `
    }

    renderFooter() {
        return ``
    }
    setupEvents() {
        this.root.querySelectorAll(".sorcistino-nav-button").forEach(button=>button.addEventListener("click",event=>this.navigate(button)))
    }
    navigate(nav) {


      if (nav.getAttribute("data-screen-nav")=="back") {
        this.show(this.screen-1);
      } else {
        
        if (this.nextBehaviour()=="afterComplete" && this.screen.completed()) {
            this.show(this.screen+1);
        } else if (this.nextBehaviour()=="nextCompletes") {
          this.screens[this.screen].complete()
        }
        

      }
    }
    next() {
      if (this.screen+1<this.screens.length) {
        this.show(this.screen+1);
      }
    }
    prev() {
      if (this.screen-1>=0) {
        this.show(this.screen-1);
      }
    }
    setNextVisibility(show=true) {

        try {
          this.nextVisibility= show
          if (show) {
              this.root.querySelector('[data-screen-nav="next"]').disabled = false;
  
          } else {
              this.root.querySelector('[data-screen-nav="next"]').disabled = true;
          }  
        } catch(e) {
          
        }
        
    }
    setBackVisibility(show=true) {
        try {
          this.backVisibility = show;
          if (show) {
            this.root.querySelector('[data-screen-nav="back"]').disabled = false;
          } else {
            this.root.querySelector('[data-screen-nav="back"]').disabled = true;
          }  
        } catch(e) {
          
        }
    }
    setProgress(perc) {
        try {
          this.root.querySelector(".js-progress").style.width=`${Math.floor(perc*100)}%`  
        } catch(e){}
        

    }
    currentScreen() {
        return this.screens[this.screen];
    }
    renderScreen() {
        this.currentScreen().render()
    }
    setScreen(index) {
        this.screen = index;
        return this.currentScreen()
    }
    setContent(content) {
      this.root.querySelector(".content").innerHTML = content;
    }

    canGoBack() {
      return this.backVisibility;
    }
    canGoForward() {
      return this.nextVisibility;
    }
    nextBehaviour() {
      return "afterComplete"
    }
    show(screen) {

        this.screen = screen;
        if (screen<0) {
            this.screen = 0;
            CnR.dispatchEvent("sorcistino:reset",this)
            return;
        }


        if (this.screen==0) {
            document.querySelectorAll(".sorcistino-nav-holder").forEach(nav=>nav.removeAttribute("hidden"));
        }
        let screenObj = this.setScreen(screen)

         

        if (screen>=0 && screen<=this.screens.length) {
            screenObj.render()
            screenObj.postRender()
            
        }
        if (this.screen+1<this.screens.length && screenObj.completed()) {
            this.setNextVisibility(true)
        } else {
              this.setNextVisibility(false)  

        }
        if (this.root.querySelector(".title")) {
            this.root.querySelector(".title").innerHTML = screenObj.title();
        }


        if (this.screen>0) {
              if (!screenObj.hideBack()) {
                 this.setBackVisibility(true)   
              } else {
                 this.setBackVisibility(false)   
              }
             

        } else {
            if (this.config.zeroButtonBehavior=="hide") {
                this.setBackVisibility(false)
            } else {
              this.setBackVisibility(true)
            }
        }


        //\/ Nav Buttons
        
       

        if (screen==0) {
            this.setProgress(0.05);
        } else if (screen==this.screens.length-1) {
            this.setProgress(1)
        } else {
          this.setProgress((screen/(this.screens.length-1))+0.05)
        }

        CnR.dispatchEvent(
            "sorcistino:screen:changed",
            this
         );

        if (this.isFinalScreen()) {
           

            document.dispatchEvent(
                new CustomEvent("sorcistino:screen:final",{bubbles:true,detail:this})
            );
            this.finalize();
        }

    }
    isFinalScreen() {
        return this.screen == this.screens.length-1;

    }
    load_data() {

    }
    finalize() {

      

    }
   
}
class SorcistinoModal extends Sorcistino {
    constructor(options) {
        super(options)
        this.root = document.querySelector(".cnr-modal .modal-text");
    }
}
class SorcistinoScreen {

    constructor(parent,data,index) {

        this.index = index;
        this.parent = parent;
        this.data = data;
        this.is_completed = false;
        this.uuid = crypto.randomUUID()
    }
    setupEvents() {

    }

    hideBack() {
      return false;
    }
    completed() {
        return this.is_completed;
    }
    complete() {
    
    }
    unComplete() {
      this.is_completed = false;
    }
    broadcastCompletion(data={}) {
      this.is_completed=true;
      CnR.dispatchEvent(
        "sorcistino:screen:completed",
        data
      )
      return this.is_completed;

    }
    data() {
        return this.data;
    }
    is_final() {
      return this.screen.hasAttribute("data-final-screen");
    }
    render() {
        return ``
        this.setupEvents()
    }
    renderContent() {
      
    }
    preserve() { return false;}
    title() {
      return 'title'
    }
    root() {
      return document.querySelector(`[data-uuid="${this.uuid}"]`)
    }
    element(selector) {
      return this.root().querySelector(selector)
    }
   
    extraButtons() { return ``;}
    addListener(selector,type,callback) {
      let element = this.element(selector);
      if (element) {
        element.addEventListener(type,callback)
      }
    }
    postRender() {}
    
}


//* map components *//

class SnappingBehaviour {
    static EXTEND = "extend"
    static TRUNCATE = "truncate"
    static CLOSEST = "closest"
}
class DrawingMode {
    static INITIALIZED = 0x01;
    static DRAWING = 0x02;
    static GATES = 0x03;
}
class Enclosure {
    constructor(points) {
        this.pointData = points;
        this.isCompleted = true;
        this.resetBounds()
    }
    setPointsLiteral(points) {
      this.pointData = points.map(point=>new google.maps.LatLng(point.lat,point.lng))
    }
    complete() { this.isCompleted = true; }
    completed() { return this.isCompleted; }
    getBounds() { return {};}
    resetBounds() {
        this.bounds = this.getBounds()
    }
    isClosed() {
        return this.isCompleted;
    }
    midPoint() {
        if (this.bounds==null) {
            this.bounds = this.getBounds()
        }
        return this.bounds.midPoint;
    }
    pointBetween(start,end) {
        return new google.maps.LatLng(
            (start.lat()+end.lat())/2,
            (start.lng()+end.lng())/2
        )
    }
    sideFaces(side) {
        return Enclosure.INDETERMINATE;
    }
    clear() {
        this.pointData = [];
        this.isCompleted = false
    }
    points(points=null) {
        if (points!=null) {
            this.pointData = points;
            this.resetBounds()
        }
        return this.pointData;
    }
    addPoint(point) {
        this.pointData.push(point)
        this.resetBounds()
    }
    hasPoints() {
        return this.pointData.length>0;
    }
    removeLastPoint() {
        this.pointData.pop()
        this.resetBounds()
    }
    lastPoint() {
        if (this.hasPoints()) {
            return this.pointData[this.pointData.length-1]
        }
        return null;
    }
    penultimatePoint() {

        if (this.hasPoints()) {
            return this.pointData[this.pointData.length-2]
        }
        return null;
    }
    getPoint(index) {
        return this.pointData[index]
    }
    leftOfCenter(point) {
        return point.lat()<this.midPoint().lat();
    }
    rightOfCenter(point) {
        return point.lat()>this.midPoint().lat();
    }
    northOfCenter(point) {
        return point.lng()<this.midPoint().lng();
    }
    southOfCenter(point) {
        return point.lng()>this.midPoint().lng();
    }
    distanceBetween(start,end) {
        let val = google.maps.geometry.spherical.computeDistanceBetween(start,end);
        return Math.round(val*100)
    }

    static UP = 0x01;
    static RIGHT = 0x02;
    static DOWN = 0x03;
    static LEFT = 0x04;
    static INDETERMINATE = 0x05;
    static CLOCKWISE = 0x06;
    static COUNTERCLOKWISE = 0x07;
}

class PolygonEnclosure extends Enclosure {
    getBounds() {
        let nw = new google.maps.LatLng(this.getPoint(0))
        let se = new google.maps.LatLng(this.getPoint(0))
        this.points().forEach(point=>{
            if (point.lat()<nw.lat()) {
                nw = new google.maps.LatLng(point.lat(),nw.lng())
            }
            if (point.lng()<nw.lng()) {
                nw = new google.maps.LatLng(nw.lat(),point.lng())

            }
            if (point.lat()>se.lat()) {
                se = new google.maps.LatLng(point.lat(),se.lng())
            }
            if (point.lng()>se.lng()) {
                se = new google.maps.LatLng(se.lat(),point.lng())
            }
        })

        return {
            "nw":nw,
            "se":se,
            "midPoint":this.pointBetween(nw,se)
        }
    }

    sideIsVertical(side) {
        let xDistance = Math.abs(side.start.lat()-side.end.lat())
        let yDistance = Math.abs(side.start.lng()-side.end.lng())
        return yDistance>xDistance;
    }
    sideIsHorizontal(side) {
        return !this.sideIsVertical(side)
    }

    sideFaces(sideIndex) {
        let directions = [Enclosure.UP,Enclosure.RIGHT,Enclosure.DOWN,Enclosure.LEFT]
        let sides = this.getSides()
        let firstSide = sides[0]
        let initialIndex = 0;
        if (this.sideIsVertical(firstSide)) {
            if (side.start.lng()<side.end.lng()) {

            }
        }



    }

    getSides(autoComplete=true) {
        let sides = [];
        for (let i=0;i<this.points().length;i++) {
            let start = this.getPoint(i);
            let end = null;
            if (i+1>=this.points().length) {
                if (autoComplete) {
                    end = this.getPoint(0)
                } else {
                    break;
                }

            } else {
                end = this.getPoint(i+1)
            }

            if (this.distanceBetween(start,end)>0) {
                sides.push(
                    {
                        "start":start,
                        "end":end,
                        "centerPoint":this.pointBetween(start,end),
                        "distance":this.distanceBetween(start,end)
                    }
                )
            }
        }
        return sides;
    }
}
class PolygonManager  {
    static DESKTOP = 0x01;
    static MOBILE = 0x02;
    static FULL = 0x03;
    static PARTIAL = 0x04;
    
    static SHOW_LIVE_ALWAYS = 0x05;
    static SHOW_LIVE_ADDING = 0x06;

    static RENDER_LIVE_ACTIVE = 0x07;
    static RENDER_LIVE_INACTIVE = 0x08;

    
    
    constructor(map,config,parent) {
        

        this.parent = parent;
        this.googleMap = map;
        this.canDropPoint = true;
        this.config = config;

        this.markers = {
            "preview-delete":[],
            "preview-add":[],
            "preview":[],
            "permanent":[],
            "drawButtons":[],
            "live":[],
            "gates":[]
        }

        this.completionMode = PolygonManager.PARTIAL;
        this.liveUpdateMode = PolygonManager.SHOW_LIVE_ADDING;
        // this.liveUpdateMode = PolygonManager.SHOW_LIVE_ALWAYS;
      
        this.liveUpdateStatus = PolygonManager.RENDER_LIVE_INACTIVE;
        this.mode = DrawingMode.INITIALIZED;
        this.snappingBehaviour = SnappingBehaviour.CLOSEST;
        
        this.contolsMode = PolygonManager.DESKTOP
        if (CnR.isMobile()) {
            this.contolsMode = PolygonManager.MOBILE;
        }

        this.gatePolys = []
        this.gateLengths = config.gateLengths;
        this.buttons = {}
        this.pointMarkers = []
        this.windows = []
        this.gates = [];
        this.assets = {};
        this.flags = {}

        this.minimumSideLength = parseFloat(config.segmentLength);
        this.snapTo = parseFloat(config.snapTo.value);
        this.snapToFeet = Math.round(this.snapTo/30.48);

        config.assets.forEach(asset=>{
          this.assets[asset.key] = {
            color: asset.color,
            description: asset.description,
            image:asset.image?asset.image.image.url:null,
            name:asset.name,
            showInLegend: asset.showInLegend && asset.showInLegend!="false"
          }
        })
       

        this.instructions = config.instructions.map(node=>{
          return {
            "title":node.title,
            "content":node.content.split("\n").filter(para=>para.length>0).map(para=>`<p class="google-maps-instructions">${para}</p>`).join("\n"),
            video:node.video,
            titleCard:node.titleCard,
          }
        })
        
        this.defaultPoint = new google.maps.LatLng(45.52003730373199,-122.66034053594124)
        


        this.googleMap.setOptions(
            {
                draggableCursor:"pointer"
            }
        )

        this.enclosure = new PolygonEnclosure([])

        this.livePoly = new google.maps.Polyline({
            path:[],
            geodesic: true,
            strokeColor: this.assets["line-preview-valid"].color,
            strokeOpacity: 1.0,
            strokeWeight: 2,
        })
        this.livePoly.setMap(map)

        this.previewPoly = new google.maps.Polyline({
            path:[],
            geodesic: true,
            strokeColor: this.assets["preview-perimeter"].color,
            strokeOpacity: 1.0,
            strokeWeight: 3,
            map:this.googleMap
        })

        this.permaPoly = new google.maps.Polygon({
            path:[],
            geodesic: true,
            strokeColor: this.assets["final-perimeter"].color,
            fillColor:"#00000080",
            strokeOpacity: 1.0,
            strokeWeight: 3,

        })
        this.previewPoly.setMap(map)

        google.maps.event.addListener(map,"mousemove",event=>{
            this.handleLiveUpdate(event)
        })

        google.maps.event.addListener(this.livePoly,"click",event=>{
            this.handleAddPoint(event)

        })
        google.maps.event.addListener(map,"click",event=>{
            this.closeToast()
            this.handleAddPoint(event)
        })
        
        this.buttons.how_to = {
          button:this.createButton(CnrVariableStore.textFor("how-to")),
          placement:google.maps.ControlPosition.RIGHT_TOP,
        }

        this.buttons.drawing = {placement:google.maps.ControlPosition.RIGHT_TOP,button:this.createButton(CnrVariableStore.textFor("restart-drawing"))};
        this.buttons.addGates = {button: this.createButton(CnrVariableStore.textFor("add-gates")),placement:google.maps.ControlPosition.RIGHT_TOP}
        this.buttons.secondary = {placement:google.maps.ControlPosition.RIGHT_BOTTOM,button:this.createButton(CnrVariableStore.textFor("continue-to-selection"))};


        this.buttons.how_to.button.addEventListener("click",event=>this.showHowTo())
        this.buttons.drawing.button.addEventListener("click",event=>this.startDrawing())
        this.buttons.secondary.button.addEventListener("click",event=>this.finalize())
        this.buttons.addGates.button.addEventListener("click",event=>this.endDrawing())

        this.zoom = 14;
        this.rotation = 0;

        this.googleMap.setOptions(
            {
                zoomControl:true,
                zoomControlOptions:{
                    position:google.maps.ControlPosition.BLOCK_END_INLINE_START
                }
            }
        
        )
        document.addEventListener("cnr:map:drawing:restart",event=>{
            this.startDrawing()
        })
          document.addEventListener("cnr:map:geometry:set",event=>{
            this.loadGeometry(event.detail)
        })
        document.addEventListener("cnr:map:geometry:reset",event=>{    
            this.loadGeometry(event.detail)
            this.startDrawing()
          
        })

        this.showHowTo();  
    }
    flagged(type) {
      return this.flags[type]
    }
    flag(type) {
      this.flags[type] = true;
    }
    unflag(type) {
      this.flags[type] = false;
    }
    
   
    /* geometry functions */

    loadGeometry(geometry) {
      this.enclosure.setPointsLiteral(geometry.enclosure)
      this.googleMap.setOptions({
        center:new google.maps.LatLng(geometry.centerPoint.lat,geometry.centerPoint.lng),
        zoom:geometry.zoom,
      })
      this.clearGateMarkers()
      this.gates = []
      this.markers.gates = []
      
      this.endDrawing(false)
      geometry.sides.forEach((side,sideIndex)=>{
        side.components.filter(component=>component.type=="gate").forEach((gate,gateIndex)=>{
          this.selectGate(
            new google.maps.LatLng(gate.marker.lat,gate.marker.lng),
            sideIndex,
            gate.width,
          )  
        })
        
      })
      
    }
    translateToPixels() {
      let projection = this.googleMap.getProjection();
      let pixels = []
      this.enclosure.points().forEach(point=>{
        let translatedPoint = projection.fromLatLngToPoint(point)
        pixels.push({x:translatedPoint.x,y:translatedPoint.y})
      })
      return pixels;
    }
    
    generateGeometry() {
      
      let sides = this.getSides();
      let centerPoint = this.googleMap.getCenter()
      let markerUrlComponents = []
        let returnValue = {
            sides:[],
            pixels:this.translateToPixels(),
            points: this.enclosure.points().length,
            enclosure: this.enclosure.points().map(point=>{return {lat:point.lat(),lng:point.lng()}}),
            encodedEnclosure:this.enclosure.points().map(point=>`${point.lat()},${point.lng()}`).join("|"),
            zoom:this.googleMap.getZoom(),
            centerPoint:{lat:centerPoint.lat(),lng:centerPoint.lng()},
            mode:"advanced"
        }

        sides.forEach((side,index)=>{
            let sideDistance = this.enclosure.distanceBetween(side.start,side.end);
            let sideValue = {
                components:[
                    {
                        type:"panel",
                        count:Math.round((sideDistance/this.minimumSideLength)*10)/10,
                        width:this.toSnappedFeet(sideDistance),
                    }
                ]
            }
            
            if (this.gates[index]) {
              this.gates[index].filter(gate=>gate!=null).forEach((gateWidth,gateIndex)=>{
                let marker = this.markers.gates[index][gateIndex]
                markerUrlComponents.push(`anchor:center|icon:${encodeURIComponent(this.assets['gate-4'].image)}|${marker.position.lat},${marker.position.lng}`)
                if (marker) {
                  sideValue.components.push(
                    {
                        type:"gate",
                        count:1,
                        width:gateWidth,
                        marker:{
                          lat:marker.position.lat,
                          lng:marker.position.lng
                        }
                    }
                  )  
                }
              })
            }
            returnValue.sides.push(sideValue)
        })
        returnValue.staticMapUrl = `https://maps.googleapis.com/maps/api/staticmap?zoom=${this.googleMap.getZoom()}&size=640x480&maptype=satellite&key=${CnrVariableStore.textFor('google-maps-api-key')}&path=color:0x${this.assets['add-gate-line'].color.replace('#','')}FF|weight:5|${this.enclosure.points().map(point=>`${point.lat()},${point.lng()}`).join("|")}&${markerUrlComponents.map(point=>`markers=${point}`).join("&")}`
        return returnValue;
    }
    broadcastGeometry() {
        this.screenshot()
        CnR.dispatchEvent(
          "cnr:mapdrawer:geometry:updated",
          JSON.parse(JSON.stringify(this.generateGeometry()))
        )
    }
    finalize() {
        CnR.dispatchEvent(
           "cnr:mapdrawer:finished",
            this.generateGeometry()
        )
    }

    getSides() { 
        let sides =  this.enclosure.getSides(this.completionMode == PolygonManager.FULL && this.enclosure.isClosed())       
        return sides;
    }
    points() { return this.enclosure.points()}
    getPoint(index) { return this.enclosure.getPoint(index)}
    lastPoint() { return this.enclosure.lastPoint()}
    penultimatePoint() { return this.enclosure.penultimatePoint()}
  
    getAngle(start,end) {
        return google.maps.geometry.spherical.computeHeading(start,end);
    }
    midPoint(start,end) {
        return new google.maps.LatLng(
            (start.lat()+end.lat())/2,
            (start.lng()+end.lng())/2
        )
    }
    clearWindows() {
        this.windows.forEach(window=>window.close())
        this.windows = []
    }
    distanceBetween(start,end) {
        let val = google.maps.geometry.spherical.computeDistanceBetween(start,end);
        return Math.round(val*100)
    }
    toFeet(value) {
        return Math.round((value/100)*3.28);

    }
    toSnappedFeet(value) {
        let distance = this.toFeet(value)
        let leftoverDistance = distance % this.snapToFeet;
        switch(this.snappingBehaviour) {
            case SnappingBehaviour.EXTEND:
                distance+=(this.snapToFeet-leftoverDistance)
                break;
            case SnappingBehaviour.TRUNCATE:
                distance-=leftoverDistance;
                break;
            case SnappingBehaviour.CLOSEST:
                if (leftoverDistance<=(this.snapToFeet/2)) {
                    distance-=leftoverDistance;
                } else {
                    distance+=(this.snapToFeet-leftoverDistance)
                }
                break;
        }
        

        return distance
    }
    toCentimeters(value) {
        return Math.round(value*30.48)
    }
    distanceBetweenInFeet(start,end) {
        let value = (this.distanceBetween(start,end)/100)*3.28;
        return Math.round(value)
    }
    getEndpoint(start,distance,angle) {
        return google.maps.geometry.spherical.computeOffset(start,distance/100,angle)
    }

     /* fraewing functions */

     setupDrawButtons() {
       if (this.completionMode == PolygonManager.FULL) {
          this.showButtons("how_to","drawing")  
        } else {
          this.showButtons("how_to","drawing");
          //this.showButtons("how_to","drawing","addGates")
        }
        this.buttons.drawing.button.textContent = CnrVariableStore.textFor("restart-drawing");
        this.buttons.secondary.button.textContent = CnrVariableStore.textFor("add-gates");
        this.buttons.secondary.button.classList.add("gate-mode")
        this.buttons.secondary.button.disabled = true;
     }
     startDrawing() {
        this.hideButtons()
         this.flag("howto-initial");
        
        this.setupDrawButtons();
        
        this.clearWindows()
        this.clearGateLines()
        this.gates = []
        this.mode = DrawingMode.DRAWING;
        this.canDropPoint = true;
        this.googleMap.setOptions(
            {
                draggableCursor:'crosshair'
            }
        )
        this.liveUpdateStatus = PolygonManager.RENDER_LIVE_ACTIVE;
        this.canDropPoint = true;
         
        this.clearPolygons(this.permaPoly,this.previewPoly,this.livePoly)
        this.enclosure.clear()
        this.clearMarkers("permanent","preview","preview-delete","preview-add","live")
        this.clearGateMarkers()
        
        this.broadcastGeometry();

    }
    endDrawing(showGatePopup=true) {
        this.clearWindows()
        this.mode = DrawingMode.INITIALIZED;
        
        this.clearPolygons(this.previewPoly,this.livePoly)
        this.clearMarkers("live","preview-delete","preview-add","drawButtons")
        this.renderPermaPoly()
        this.broadcastGeometry()
        this.buttons.secondary.button.disabled = false;
        if (!this.hasShownGatePopup) {
          
        }
        if (!this.flagged("add-gates-popup")) {
          this.showToast(CnrVariableStore.textFor("add-gates-popup-text"))
          this.flag("add-gates-popup")
        }
        
        this.startAddGates()
    }
    clearGateLines() {
        this.gatePolys.forEach(poly=>poly.setMap(null))
        this.gatePolys = []; 
    }
    setGate(sideIndex,gateIndex,value) {
      if (!this.gates[sideIndex]) {
        this.gates[sideIndex] = []
      }
      this.gates[sideIndex][gateIndex]=value;
    }
    
    startAddGates() {
        this.mode = DrawingMode.INITIALIZED;
        
        this.clearWindows()
        this.clearMarkers("gates","preview")
        this.clearGateLines()
        this.permaPoly.setMap(null)
        this.showButtons("how_to","drawing","secondary")
        this.buttons.secondary.button.textContent = CnrVariableStore.textFor("continue-to-selection");
        this.buttons.secondary.button.classList.remove("gate-mode")
        this.getSides().forEach((side,index)=>{
            let gatePoly = new google.maps.Polyline({
              path:[side.start,side.end],
              geodesic: true,
              strokeColor: this.assets["add-gate-line"].color,
              strokeOpacity: 1.0,
              strokeWeight: 6,
              map: this.googleMap
          })     
          google.maps.event.addListener(gatePoly,"click",event=>{
            this.closeToast();
            this.addGatePopup(event.latLng,index);
          })
          this.gatePolys.push(gatePoly)
        })
    }
    canShowLive() {
        if (this.liveUpdateMode==PolygonManager.SHOW_LIVE_ADDING) {
          if (this.liveUpdateStatus==PolygonManager.RENDER_LIVE_INACTIVE) {
            return false
          }
        }
        return true
    }
    handleAddPoint(event) {
        if (this.mode!=DrawingMode.DRAWING) {
            return
        }
        if (this.liveUpdateMode==PolygonManager.SHOW_LIVE_ADDING) {
          if (this.liveUpdateStatus==PolygonManager.RENDER_LIVE_INACTIVE) {
            if (this.points().length>2)
            return;
          }  
        }
        
        let droppedPoint = event.latLng
        if (this.canDropPoint) {
            if (this.lastPoint()) {
                let segmentLength = this.distanceBetween(this.lastPoint(),droppedPoint)
                let segmentLengthAdjusted = this.adjustedLength(this.lastPoint(),droppedPoint)
                let angle = this.getAngle(this.lastPoint(),droppedPoint)
                let potentialEndpoint = this.getEndpoint(this.lastPoint(),segmentLengthAdjusted,angle)
                droppedPoint = potentialEndpoint
                if (this.liveUpdateMode==PolygonManager.SHOW_LIVE_ADDING) {
                  this.liveUpdateStatus = PolygonManager.RENDER_LIVE_INACTIVE;
                }
                this.canDropPoint = false;
            } else {
                if (this.liveUpdateMode==PolygonManager.SHOW_LIVE_ADDING) {
                  this.liveUpdateStatus = PolygonManager.RENDER_LIVE_ACTIVE;
                }
            }
            this.enclosure.addPoint(droppedPoint)
            if (this.points().length>1) {
              this.showButtons("how_to","drawing","addGates")
            }
            this.broadcastGeometry();
            this.clearMarkers("live")
            this.renderPreviewPoly()
        }
    }
   


    renderPreviewPoly() {

        this.renderPoly(this.previewPoly,"preview")
    }
    
   
    renderPermaPoly() {
        this.clearPolygons(this.previewPoly)
        this.previewPoly.setMap(null)
        this.renderPoly(this.permaPoly,"permanent")
    }

    
    clearPolygons() {
        Array.from(arguments).forEach(polygon=>{
            polygon.setPath([])
        })
    }
    
    renderPoly(polyObject,markerType) {

        polyObject.setPath(this.points())
        polyObject.setMap(this.googleMap)
        this.clearMarkers(markerType,"preview-delete","preview-add")
        

        if (this.mode==DrawingMode.DRAWING && !this.polygonComplete) {
            for (let i=0;i<this.points().length-1;i++) {
                
                
                if (i==0) {
                    let marker = this.createIconMarker(this.enclosure.getPoint(i),(i==0)?this.assets["first-corner"].image:this.assets.corner.image)
                    this.markers[markerType].push(marker)
                    google.maps.event.addListener(marker,"click",event=>{
                        this.enclosure.addPoint(new google.maps.LatLng(this.getPoint(i)))
                        this.enclosure.complete()
                        this.endDrawing()
                    })
                }
                
            }

            if (this.points().length==1 || this.liveUpdateMode==PolygonManager.SHOW_LIVE_ALWAYS) {
              let deleteMarker = this.createDeleteMarker(this.lastPoint())
              this.markers["preview-delete"].push(deleteMarker)          
            } else {
              let lastPoint = this.lastPoint();
              let penultimatePoint = this.penultimatePoint();
              let side = {
                start:penultimatePoint,
                end:lastPoint
              }
              let deletePlacementPoint = this.createDeleteMarker(
                this.getEndpoint(
                  penultimatePoint,
                  this.distanceBetween(penultimatePoint,lastPoint)*.75,
                  this.getAngle(penultimatePoint,lastPoint)
                )
              )
              this.markers["preview-delete"].push(deletePlacementPoint)
              let addPointMarker = this.createAddPointMarker(
                this.lastPoint()
              )  
              this.markers["preview-add"].push(addPointMarker)
            }
            /*
            
          */
        }
        this.getSides().forEach((side,index)=>{

            let angle = this.getAngle(side.start,side.end);
            let anchorPoint = this.getEndpoint(side.start,this.distanceBetween(side.start,side.end)/4,angle)
            
            let marker = this.createTextMarker(anchorPoint,`${this.toSnappedFeet(this.distanceBetween(side.start,side.end))}ft`)
            this.markers[markerType].push(marker)
        })
    }

    /* marker/button functions */
    createDeleteMarker(endPoint) {
        let marker = this.createIconMarker(endPoint,this.assets.delete.image)
            
        google.maps.event.addListener(marker,"click",event=>{
          this.enclosure.removeLastPoint()
          if (this.points().length<1) {
            marker.setMap(null)
            this.canDropPoint = true;
            this.clearMarkers("live")
                    
          } else {
            if (this.points().length==1) {
                this.liveUpdateStatus = PolygonManager.RENDER_LIVE_ACTIVE;
                this.canDropPoint = false;
            } else {
              if (this.liveUpdateMode==PolygonManager.SHOW_LIVE_ADDING) {
                this.liveUpdateStatus = PolygonManager.RENDER_LIVE_INACTIVE;
                this.canDropPoint = false;  
              }
            }
            
            this.livePoly.setPath([])
            this.renderPreviewPoly()
                      
        }
  
      })
      return marker
    }
    createAddPointMarker(endPoint) {
        let marker = this.createIconMarker(endPoint,this.assets["add-side"].image)
        google.maps.event.addListener(marker,"click",event=>{
          this.canDropPoint = true;
          this.liveUpdateStatus = PolygonManager.RENDER_LIVE_ACTIVE;

      })
      return marker
    }
    createTextMarker(point,text) {
        let textElement = document.createElement("div")
        textElement.textContent = text;
        textElement.classList.add("annotation")
        return this.createMarker(point,textElement,google.maps.CollisionBehavior.OPTIONAL_AND_HIDES_LOWER_PRIORITY)
    }
    
    createIconMarker(point,src) {
        let icon = document.createElement("img");
        icon.src = src;
        return this.createMarker(point,icon,google.maps.CollisionBehavior.REQUIRED_AND_HIDES_OPTIONAL)
    }
    createMarker(point,element,behavior) {
        let marker = new google.maps.marker.AdvancedMarkerElement(
            {
                map:this.googleMap,
                content:element,
                position:point,
                collisionBehavior:behavior,
            }
        )
        marker.content.style.transform = 'translateY(50%)'
        return marker
    }

    hideButtons() {
        this.parent.locationSearch.style.display="none";
        
        [google.maps.ControlPosition.RIGHT_TOP,google.maps.ControlPosition.RIGHT_BOTTOM].forEach(placement=>{
          while (this.googleMap.controls[placement].length>0) {
            this.googleMap.controls[placement].pop()
          }  
        })    
      }
      showButtons() {
        this.hideButtons()
        Array.from(arguments).forEach(button=>{
          this.googleMap.controls[this.buttons[button].placement].push(this.buttons[button].button)
        });
        this.parent.locationSearch.style.display="block";
      }
    createButton(text) {
        let button = document.createElement("button");
        button.classList.add("google-maps-button")
        button.innerHTML = text;
        return button;
    }

    clearMarkers() {
        Array.from(arguments).forEach(which=>{
            if (this.markers[which]) {
                if (!Array.isArray(this.markers[which])) {
                  this.markers[which].forEach(multiside=>multiside.forEach(marker=>marker.setMap(null)))
                } else {
                  this.markers[which].forEach(marker=>{
                    try {
                      marker.setMap(null)
                    } catch(e) {
                      
                    }
                  })
                  this.markers[which] = []
                }
                
            }
        })
    }
    clearGateMarkers() {
      
      for(let side=0;side<this.markers.gates.length;side++) {
        if (this.markers.gates[side]) {
          this.markers.gates[side].forEach(marker=>{
            marker.setMap(null)
          })
        }
      }

      this.markers.gates = []
    }

    setGateMarker(sideIndex,gateIndex,value) {
      
        if (!this.markers.gates[sideIndex]) {
          this.markers.gates[sideIndex] = []
        }
        this.markers.gates[sideIndex][gateIndex]=value;
      }
      orientMarkerToSide(segment,marker) {
        let angle = this.getAngle(segment.start,segment.end);
          if (angle<0) {
              angle+=360;
          }
          if (this.enclosure.rightOfCenter(new google.maps.LatLng(marker.position.lat,marker.position.lng))) {
              angle+=90
          } else {
              angle+=90;
          }
  
          marker.content.style.transformOrigin = "center"
          marker.content.classList.add("google-maps-gate-icon")
          marker.content.style.transform = ` translateY(50%) rotate(${angle}deg)`
          
      }
   
    
    /* windows/popups */

    

    windowTitle(text) {
      let span = document.createElement("span")
      span.classList.add("google-maps-window-title");
      span.textContent = text;
      return span;
    }
    getNorthWest(bounds) {
      return new google.maps.LatLng(
          bounds.getNorthEast().lat(),
          bounds.getSouthWest().lng()
        )
    }
    showToast(text,duration=2500) {
      let bounds = this.googleMap.getBounds();
      let centerPoint = this.enclosure.pointBetween(bounds.getNorthEast(),this.getNorthWest(bounds))
      let textElement = document.createElement("div")
      textElement.innerHTML = text.split("\n").map(line=>`<p>${line}</p>`).join("\n")
      textElement.classList.add("google-maps-toast")

      this.toastMarker = this.createMarker(
        this.googleMap.getCenter(),
        textElement,google.maps.CollisionBehavior.REQUIRED_AND_HIDES_OPTIONAL
      );
      
      
      google.maps.event.addListener(this.toastMarker,"click",event=>{
          this.closeToast()
      })
      
      window.setTimeout(()=>
        {
          
          this.closeToast();
        },
        CnrVariableStore.intFor("toast-delay")
      )
      //this.toastMarker.setMap(this.googleMap)
    }
    hasToast() { return this.toastMarker!=null;}
    closeToast() {
      
      if (this.hasToast()) {
        this.toastMarker.setMap(null)
        this.toastMarker = null;  
      }
    }
    clearActiveWindow() {
      if (this.activeWindow) {
        this.activeWindow.close();
        this.activeWindow = null;
      }
    }
    showHowTo() {
      
        if (this.howToWindow) {
          return;
        }
        this.hideButtons();
        let infoDiv = document.createElement("DIV")
        infoDiv.classList.add("google-maps-howto")
        
        let renderTextContent = (node)=>{
          
          return `
              <div class="section-header">${node.title}</div>
              <div class="howto-body">${node.content}</div>
            `
        }
        let renderVideoContent = (node)=>{
          return `
            <div class="section-header">${node.title}</div>
            <div class="instruction-video">
              <video poster="${node.titleCard.image.url}" controls class="howto-video">
                ${node.video.sources.map(source=>`<source src="${source.url}" type="${source.type}"/>`).join("")}
              </video>
            </div>
          `
        }
      
        infoDiv.innerHTML = `
          <div class="section-header">${CnrVariableStore.textFor('completion-mode-header')}</div>
          <div class="mode-buttons">
            <button class="google-maps-button small partial-mode ">${CnrVariableStore.textFor('completion-mode-draw')}</button>
            <button class="google-maps-button small basic-mode">${CnrVariableStore.textFor('completion-mode-basic')}</button>
          </div>
          <div class="instructions">
            ${this.instructions.map(entry=>entry.video?renderVideoContent(entry):renderTextContent(entry)).join('')}
          </div>
          <div class="section-header">${CnrVariableStore.textFor('legend')}</div>
          <div class="legend">
            ${Object.values(this.assets).filter(asset=>asset.showInLegend).map(asset=>`
          <div class="legend-row">
            <div class="legend-image"><img src="${asset.image}"></div>
            <div class="legend-text">${asset.description}</div>
          </div>
        `).join("")}
          </div>
        `
        this.howToWindow = new google.maps.InfoWindow({
            position:this.googleMap.getCenter(),
            content:infoDiv,
            ariaLabel: CnrVariableStore.textFor("how-to-popup","How-to"),
            headerContent:this.windowTitle(CnrVariableStore.textFor("how-to-popup","How-to")),
            zIndex:10000000

        });
        google.maps.event.addListener(this.howToWindow,"close",event=>{
          this.howToWindow = null;
          if (!this.flagged("howto-initial")) {
            this.startDrawing();  
          } else {
            this.setupDrawButtons()
          }
          
        })
      
        
        infoDiv.querySelector(".partial-mode").addEventListener("click",event=>{
          this.completionMode = PolygonManager.PARTIAL;
          this.howToWindow.close()
        })
      
        infoDiv.querySelector(".basic-mode").addEventListener("click",event=>{
          event.preventDefault();
          event.stopPropagation();
          CnR.dispatchEvent(
            "cnr:mapdrawer:setMode",
            "basic"
          )
        })
        
        this.howToWindow.open(this.googleMap)
    }

   

    addGatePopup(anchorPoint,sideIndex) {
        let frag = document.createDocumentFragment()
        let holderDiv = document.createElement("DIV")

        holderDiv.innerHTML = `
        <div class="google-maps-fence-selector">
            ${Object.keys(this.gateLengths).map(gateLength=>`
              <div class="gate-selector-button">
                <button data-option="ten-foot" class="google-maps-button small" data-length="${gateLength}">${gateLength}' Gate</button>
            </div>  
            `).join("\n")}
        </div>
        <div class="gate-selector-cancel">
                <button data-option="cancel" class="google-maps-button small">Cancel</button>
        </div>
        `

        let gateInfoWindow = new google.maps.InfoWindow({
            content:holderDiv,
            position:anchorPoint,
            ariaLabel: CnrVariableStore.textFor('select-gate-header'),
            headerContent:this.windowTitle(CnrVariableStore.textFor('select-gate-header'))

        });
        this.windows.push(gateInfoWindow)
        gateInfoWindow.open(this.googleMap)

        let infoWindowContent = gateInfoWindow.getContent();
        infoWindowContent.querySelectorAll("[data-length]").forEach(lengthSelector=>{
          lengthSelector.addEventListener("click",event=>{
            gateInfoWindow.close()
            this.selectGate(anchorPoint,sideIndex,parseInt(lengthSelector.dataset.length))  
          })
          
        })
        infoWindowContent.querySelector('[data-option="cancel"]')
          .addEventListener("click",event=>{
            gateInfoWindow.close()
          });
    }
    removeGatePopup(anchorPoint,sideIndex,gateIndex) {
        
        let holderDiv = document.createElement("DIV")

        holderDiv.innerHTML = `
        <div class="google-maps-fence-selector">
            <div class="gate-remover-button">
                <button data-option="remove-gate" class="google-maps-button small">${CnrVariableStore.textFor('remove-gate-header')}</button>
            </div>
            <div class="gate-selector-button">
                <button data-option="cancel" class="google-maps-button small">Cancel</button>
            </div>
        `
        let gateInfoWindow = new google.maps.InfoWindow({
            content:holderDiv,
            position:anchorPoint,
            ariaLabel: CnrVariableStore.textFor('remove-gate-header'),
            headerContent:this.windowTitle(CnrVariableStore.textFor('remove-gate-header'))

        });
        this.windows.push(gateInfoWindow)
        gateInfoWindow.open(this.googleMap)
        holderDiv.querySelector('[data-option="remove-gate"]')
            .addEventListener("click",event=>{
                gateInfoWindow.close()
                this.removeGate(sideIndex,gateIndex)

            });
            holderDiv.querySelector('[data-option="cancel"]')
            .addEventListener("click",event=>{
                gateInfoWindow.close()
        });
    }
    removeGate(sideIndex,gateIndex) {
        this.setGate(sideIndex,gateIndex,null)
        let sides = this.getSides()
        
        let gate = this.markers["gates"][sideIndex][gateIndex];
        gate.setMap(null)
        this.broadcastGeometry()
    }
    selectGate(anchorPoint,sideIndex,length) {
        let sides = this.getSides()
        let gateSide = this.getSides()[sideIndex]
        let gateIndex = this.gates[sideIndex]?this.gates[sideIndex].length:0;
        
        this.setGate(sideIndex,gateIndex,length)
        let assetId = "gate-4"
        let gateMarker = this.createIconMarker(
          anchorPoint,
          this.assets[assetId].image
        );
        google.maps.event.addListener(gateMarker,"click",event=>{
            this.removeGatePopup(anchorPoint,sideIndex,gateIndex)
        })
        this.setGateMarker(sideIndex,gateIndex,gateMarker)
        this.orientMarkerToSide(gateSide,gateMarker)
        
        this.broadcastGeometry()


    }
    


    adjustedLength(start,end) {
        let lineDistance = this.distanceBetween(start,end)
        let startingLineDistance = lineDistance;
        
        let leftoverDistance = lineDistance % this.snapTo
        switch(this.snappingBehaviour) {
            case SnappingBehaviour.EXTEND:
                lineDistance+=(this.snapTo-leftoverDistance)
                break;
            case SnappingBehaviour.TRUNCATE:
                lineDistance-=leftoverDistance;
                break;
            case SnappingBehaviour.CLOSEST:
                if (leftoverDistance<=(this.snapTo/2)) {
                    lineDistance-=leftoverDistance;
                } else {
                    lineDistance+=(this.snapTo-leftoverDistance)
                }
                break;
        }

        return lineDistance;
    }
    handleLiveUpdate(event) {

        if (this.mode!=DrawingMode.DRAWING) {
            
            return;
        }
        if (this.liveUpdateMode==PolygonManager.SHOW_LIVE_ADDING) {
          if (this.liveUpdateStatus!=PolygonManager.RENDER_LIVE_ACTIVE) {
            return
          }
        }
        

        if (this.points().length<1) {
            return [this.lastPoint(),event.latLng]
        }
        this.clearMarkers("live")
        let livePoints = [this.lastPoint(),event.latLng];
        if (this.completionMode == PolygonManager.FULL) {
          livePoints.push(this.getPoint(0))
        }
        this.livePoly.setPath(new google.maps.MVCArray(livePoints));
        this.livePoly.setMap(this.googleMap)
        let lineDistance = this.distanceBetween(this.lastPoint(),event.latLng)
        let lineDistanceToClose = this.distanceBetween(event.latLng,this.getPoint(0))
        let finishMidpoint = this.midPoint(event.latLng,this.getPoint(0))
        let angle = this.getAngle(this.lastPoint(),event.latLng)
        let anchorPoint = this.midPoint(this.lastPoint(),event.latLng)

        if (lineDistance<this.minimumSideLength) {
            this.canDropPoint = false
            this.livePoly.setOptions({strokeColor:this.assets["line-preview-invalid"].color})
        } else {
            this.canDropPoint = true
            this.livePoly.setOptions({strokeColor:this.assets["line-preview-valid"].color})
        }
        if (this.canDropPoint) {
            
            if (this.showliveMarkers || true) {
              if (!this.liveMarkerWait) {
                this.liveMarkerWait = true;
                setTimeout(()=>{
                    this.liveMarkerWait = false;
                    this.markers["live"].push(this.createTextMarker(anchorPoint,`${this.toSnappedFeet(lineDistance)}ft`))
                    if (this.completionMode == PolygonManager.FULL) {
                      this.markers["live"].push(this.createTextMarker(finishMidpoint,`${this.toSnappedFeet(lineDistanceToClose)}ft`))
                    }
                },20);
              }  
            }
            
        }
    }
    screenshot() {
      return;
     html2canvas(document.querySelector("#google-map"), {
       useCORS: true,
       onrendered: function(canvas) {
            let popupHtml = `
              <img src="${canvas.toDataURL()}">
              
            `;
           CnRModal.show(popupHtml)
           }
        });
    }
}


class CnrInteractiveMap extends CnR {
    constructor(options) {
        super(options)
        this.markers = []
        this.position = {
            "latitude":45.52003730373199,
            "longitude":-122.66034053594124
        }

        this.loadData()

    }
    loadData() {
        if (this.snapToPosition()) {
            navigator.geolocation.getCurrentPosition(
                (pos)=>{

                    this.position = {
                        "latitude":pos.coords.latitude,
                        "longitude":pos.coords.longitude,
                    }
                    this.setupMap()
                },
                (error)=>{
                    console.error(error)
                    this.setupMap()
                },
                {
                    enableHighAccuracy: true,
                    timeout: 5000,
                    maximumAge: 0,
                  }
            );
        }

    }
    injectionPoint() {
        return document.querySelector(".google-map-holder")
    }
    autoComplete(event) {

        var places = this.searchBox.getPlaces();
        if (places.length == 0) {
        return;
        }
        this.markers.forEach(marker=>marker.setMap(null))
        this.markers = [];
        var bounds = new google.maps.LatLngBounds();
        places.forEach(place=>{
            
            bounds.extend(place.geometry.location)
            

        });
        this.map.fitBounds(bounds);
        CnR.dispatchEvent(
          "cnr:map:drawing:restart",
          null
        )
    }
    setupMap() {
        let root = this.injectionPoint();
        let map = document.createElement("DIV")
        map.id = "google-map"
        map.classList.add("google-map")
        root.appendChild(map)
        var cnrMapType = new google.maps.StyledMapType([  ], {
            name: 'Map'
        });
        var cnrMapStyle = 'cnr-maps';

        this.map = new google.maps.Map(map, {
            center: new google.maps.LatLng(this.position.latitude,this.position.longitude),
            zoom: 14,
            tilt:0,
            rotateControl: false,
            mapTypeId:"satellite",
            mapId:this.config.googleMapId,
            //mapId:"dd5b42e1f0e1dd7c",
            fullscreenControl: false,
            disableDefaultUI:true,
            styles:[
                {
                    elementType: "labels.icon",
                    stylers: [{ visibility: "off" }],
                  }
            ]
        })

        this.locationSearch = document.createElement("input")
        this.locationSearch.classList.add("google-maps-search-box")
        this.locationSearch.type = "text"
        this.locationSearch.placeholder = CnrVariableStore.textFor('location-search-placeholder');

        this.map.controls[google.maps.ControlPosition.TOP_LEFT].push(this.locationSearch);
        this.searchBox = new google.maps.places.SearchBox((this.locationSearch));
        google.maps.event.addListener(this.searchBox, 'places_changed', event=>{
            this.autoComplete(event)
        });



    }

}



class CnrPolygonMap extends CnrInteractiveMap {
    setupMap() {
        super.setupMap();
        
        this.shapeManager = new PolygonManager(this.map,this.config.config,this)
    }
}

class SpAppBridge {
  constructor(options) {
    this.config = options;
    this.opportunityId = localStorage.getItem("ghlOpportunityId");
    this.contactId = localStorage.getItem("ghlContactId")
    
    document.addEventListener("ghl:data:submit",event=>{
      if (this.opportunityId==null) {
        this.submitData(event.detail)
      }
    })
    document.addEventListener("ghl:note:add",event=>{
      if (this.contactId) {
        this.post(
          `ghl/update`,
          {
            "body":event.detail,
            "contactId":this.contactId
          }
        )
      }
    })  
      
      
  }
  hasContact() {
    return this.contactId!=null;
  }
  async get(path) {
    return fetch(
      `${CnrVariableStore.textFor("custom-app-url")}${path}`,
      {
        method: 'GET',
        headers: {
          'Content-Type': 'application/json',
        }
      }
    ).then(response=>response.json())
  }
  async post(path,data) {
    return fetch(
      `${CnrVariableStore.textFor("custom-app-url")}${path}`,
      {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
        },
        body:JSON.stringify(data)
      }
    ).then(response=>response.json())
  }
  setOpportunityData(opportunityId,contactId) {
    this.opportunityId = opportunityId;
    this.contactId = contactId,
    localStorage.setItem("ghlOpportunityId",opportunityId);
    localStorage.setItem("ghlContactId",contactId)
  }
  submitData(data) {
    this.post("ghl/collect",data).then(response=>{
      if (response.opportunity.id) {
        this.setOpportunityData(response.opportunity.id,response.opportunity.contact.id)
        CnRModal.close()
      }
      else {
        this.get(`ghl/find/${data.email}`).then(response=>{
          this.setOpportunityData(response.opportunityId,response.contactId)
        })
        
        CnRModal.close();
      }
      
      
    })
  }
}

class SevenPeaksInteractiveMap extends CnrPolygonMap {
    constructor(options) {
        super(options)
        this.position = {
            "latitude":32.86973595439656,
            "longitude":-96.64901936921868
        }
    }
    snapToPosition() {
        return true;
    }
}

class CnRBasketHandler {
    constructor() {
      this.baskets = []
      this.newBasket()
    }
    count() {
      return this.baskets.length;
    }
    contents(basketIndex) {
      if (!basketIndex) {
        basketIndex = this.basketIndex
      }
      return this.baskets[basketIndex].contents
    }
    load(index) {
      if (this.baskets[index]) {
        this.basketIndex = index
      }
      return this;
    }
    setComplete(basketIndex=null) {
      
      if (!basketIndex) {
        basketIndex = this.basketIndex;
      }
      this.baskets[basketIndex].complete = true;
      
    }
    unComplete(basketIndex=null) {
      if (!basketIndex) {
        basketIndex = this.basketIndex;
      }
      this.baskets[basketIndex].complete = false;
      
    }
    isComplete(basketIndex=null) {
      if (!basketIndex) {
        basketIndex = this.basketIndex;
      }
      
      return this.baskets[basketIndex].complete
    }
    clone(index) {
      if (this.get(index)) {
        
        let clonedBasket = JSON.parse(JSON.stringify(this.get(index)))
        clonedBasket.id = crypto.randomUUID()
        
        this.baskets.push(clonedBasket)
        this.basketIndex = this.baskets.length-1;
        
      }
      
    }
    newBasket() {
      
      let currentBasket = this.get();
      this.basketIndex = this.baskets.length;
      let geometry = {sides:[],points:0,enclosure:[]}
      if (currentBasket) {
        geometry.zoom = currentBasket.geometry.zoom;
        geometry.centerPoint = currentBasket.geometry.centerPoint;
      }
      this.baskets.push({
        "id":crypto.randomUUID(),
        "contents":{},
        geometry: geometry,
        complete: false
      })
      return this;
    }
    clear(index=null) {
      if (index==null) {
        index = this.basketIndex;
      }
      this.baskets[index].complete = false;
      this.baskets[index].contents={};
      
      return this;
    }
    save() {}
    loadAll(basketsObject) {
      if (basketsObject) {
          this.baskets = basketsObject;
          this.basketIndex = this.baskets.length-1;  
        } else {
          this.newBasket()
        }
    }
    render(basketIndex=null) {}
    renderBasketEntry(basketIndex,entry,details) {}
  
   clearSection(section) {
      delete this.baskets[this.basketIndex].contents[section]
   }
    get(index=null) {
      if (index==null) { index = this.basketIndex;}
      return this.baskets[index]
    }
    getSection(section,basketIndex) {
      
      return this.get(basketIndex).contents[section]
    }
    setSection(type,value) {
        this.baskets[this.basketIndex].contents[type] = value
    }
    total(index=null) {
          let total = 0;
          Object.values(this.get(index).contents).forEach(basket=>{
              total+=basket.reduce((a,b)=>a+(b.product.variant[0].price.amount*b.quantity),0)
          })
          return formatMoney(total*100)
    }
    updateQuantity(basketIndex,variantId,quantity) {
        
        Object.values(this.baskets[basketIndex].contents).forEach(productSet=>{
          productSet.forEach(entry=>{
            if (entry.id==variantId)
                entry.quantity = quantity;    
            })
        })
    }
    variantImage(product,variant) {  
    
    if (variant.image) {
      return variant.image.url.split("?")[0];
    }
    return product.featuredImage.url.split("?")[0]
  }
  variantImageAlt(product,variant) {
    if (variant.image) {
      return variant.image.alt;
    }
    return product.featuredImage.alt
  }
  lineItemProperties(item) {
    return {}
  }
  async addToCart(basketIndex=null,extraProperties={}) {
    
      let payload = {items:[]}
      let basket = this.baskets[basketIndex]
    
      Object.values(basket.contents).forEach(productSet=>{
        productSet.forEach(entry=>{
          if (!entry.hiddenItem) {
            payload.items.push({
              id:entry.id.split("/").pop(),
              quantity:entry.quantity,
              properties:{...this.lineItemProperties(basket,entry),...extraProperties}
            })
          }
        })
      })
    
      payload.items = payload.items.reverse()
      let config = {
          method: 'POST',
          credentials: 'include',
          headers: {
              'Content-Type': 'application/json',
          },
          body: JSON.stringify(payload),
      }
      return fetch("/cart/add.js",config)
          .then((response) => response.json())
    }
    delete(basketIndex) {
      this.baskets[basketIndex] = null;
      this.baskets = this.baskets.filter(basket=>basket!=null)
      this.basketIndex = this.baskets.length-1;
      
    }
}

class SpBasketHandler extends CnRBasketHandler {
    
    save() {
      sessionStorage.setItem(
        "fence-builder-basket",
        JSON.stringify(this.baskets)
      )
    }
    getGeometry(index=null) {
      if (index==null) {
        index = this.basketIndex;
      }
      
      return this.get(index).geometry;
    }
    
    setGeometry(geometry) {
        this.baskets[this.basketIndex].geometry = geometry;
        if (geometry.sides.length<1) {
          this.clear()
          
        }
        return this;
    }
    clearSection(section) {
      super.clearSection(section)
      if (section=="clips") {
        if (this.baskets[this.basketIndex].contents["screws"]) {
          delete this.baskets[this.basketIndex].contents["screws"]  
        }
      }
    }
    
    setGate(index,contents) {
      if (!this.baskets[this.basketIndex].contents.gates) {
        this.baskets[this.basketIndex].contents.gates = []
      }
      this.baskets[this.basketIndex].contents.gates[index] = contents
    }
    clearGates() {
      this.baskets[this.basketIndex].contents.gates = []
    }
    consolidated(index=null) {
      let basket = this.get(index).contents
      let groups = {
          "hardware":[]
        }
        if (basket["panels"]) {
          groups["panels"] = basket["panels"]
        }
        if (basket["posts"]) {
          groups["posts"] = basket["posts"]
        }
        if (basket["gates"]) {
          let consolidatedItems = {}
          basket["gates"].forEach(gate=>{
            let variantId = gate.id;
            if (consolidatedItems[variantId]) {
              consolidatedItems[variantId].quantity+=gate.quantity;
            } else {
              consolidatedItems[variantId] = {
                id:gate.id,
                product:gate.product,
                variant: gate.variant,
                quantity:gate.quantity
              }
            }
          })
          groups["gates"] = Object.values(consolidatedItems)
        }
        ["caps","clips","clamps","screws"].forEach(category=>{
          if (basket[category]) {
            basket[category].forEach(item=>groups["hardware"].push(item))
          }
        })
        return groups
    }
    
    

    render(basketIndex=null) {
      let groups = this.consolidated(basketIndex)
      let retVal = ["panels","gates","posts","hardware"].map(
          basketCase=>{
            if (groups[basketCase] && groups[basketCase].length>0) {
             
              if (groups[basketCase].find(item=>!item.hiddenItem)) {
                return this.renderBasketEntry(basketIndex,basketCase,groups[basketCase]);
              } else {
                return this.renderEmptyBasketEntry(basketIndex,basketCase,groups[basketCase])
              }
            } else {
              return '';
            }
          }
        ).join("");
      
      return retVal
    }
  
    recommendedLabel(item) {
      if (!item.recommended) {
        return '';
      }
      if (parseInt(item.quantity)<parseInt(item.recommended)) {
            return 'less than recommended'
      } else if (parseInt(item.quantity)>parseInt(item.recommended)) {
        return "more than recommended"
      } else {
        return "recommended"
      }
    }
    renderBasketEntry(basketIndex,entry,details) {
        
        return `
            <div class="items-category">
              <div class="items-category-label">${entry.capitalize()}:</div>
              <div class="line-items">
                ${details.map(item=>`
                
                <div class="line-item active-item" data-product="${item.id}" data-screen="${item.screen}" ${item.hiddenItem?'hidden-item':''}>
                  <div class="product-image"><img src="${this.variantImage(item.product,item.variant)}?width=105&height=93&crop=center" alt="${this.variantImageAlt(item.product,item.variant)}"></div>
                  <div class="details">
                    <div class="product-title">${item.product.title} ${item.variant.title.includes("Default")?'':item.variant.title}</div>
                    <div class="item-details">
                      <div class="quantity-field">${new CnrQuantity({value:item.quantity,dataset:{productId:item.id,recommended:item.recommended,basket:basketIndex}}).render()}</div>
                      <div class="quantity-label">${this.recommendedLabel(item)}</div>
                      
                    </div>
                    <div class="change-item" data-screen="${item.screen}" data-basket="${basketIndex}">${item.hiddenItem?'Add':'Change'} ${item.label} Type</div>
                  </div>
                </div>
            `).join("")}
            </div>
          </div>
        `
      }
    renderEmptyBasketEntry(basketIndex,entry,details) {
        
        return `
            <div class="items-category " data-screen="${entry.screen}">
              <div class="items-category-label">${entry.capitalize()}:</div>
              <div class="line-items">
                ${details.map(item=>`
                
                <div class="line-item hidden-item" data-product="${item.id}" data-screen="${item.screen}">
                  <div class="product-image"><img src="${this.variantImage(item.product,item.variant)}?width=105&height=93&crop=center" alt="${this.variantImageAlt(item.product,item.variant)}"></div>
                  <div class="details">
                    <div class="product-title">${item.product.title} ${item.variant.title.includes("Default")?'':item.variant.title}</div>
                    <div class="change-item" data-screen="${item.screen}" data-basket="${basketIndex}">Add ${item.label} Type</div>
                  </div>
                </div>
            `).join("")}
            </div>
          </div>
        `
      }
    lineItemProperties(basket,item) {
      
      return {"_fenceBuilderId":basket.id}
    }
  
  }

class SpFenceBuilder extends Sorcistino {
    constructor(options) {
        super({...options,class:"fence-builder"})
        this.screenData = {}
        this.basket = new SpBasketHandler().clear()
        this.data = {}

      this.appBridge = new SpAppBridge({});
        
      this.geometryData = {sides:[],points:0}
      document.addEventListener("cnr:mapdrawer:geometry:updated",event=>{
        this.updateGeometry(event.detail)
        this.basket.unComplete()
        this.basket.setGeometry(event.detail)
        this.reRenderBasket()
      })
      document.addEventListener("cnr:quantity:changed",event=>{
        this.updateProductQuantity(event.detail.dataset)
      })
      document.addEventListener("cnr:fence-builder:add-quote",event=>{
        
        this.basket.newBasket()
        this.show(0);
        this.screens.forEach(screen=>screen.unComplete())
        
        CnR.dispatchEvent(
          "cnr:map:geometry:reset",
          this.basket.get().geometry
        )
        
      });
      document.addEventListener("cnr:fence-builder:edit-fence",event=>{
        this.basket.load(parseInt(event.detail))
        this.show(0);
        this.screens.forEach(screen=>screen.unComplete())
        
        CnR.dispatchEvent(
          "cnr:map:geometry:set",
          this.basket.get().geometry
        )
      })
      document.addEventListener("cnr:fence-builder:clone-fence",event=>{
        this.basket.clone(parseInt(event.detail))
      })
      document.addEventListener("sorcistino:screen:changed",event=>{
        
        CnR.scrollToTarget(".builder-header")
        //document.querySelector(".section-header").scrollIntoView({behavior:"smooth","block":"start"})
      })
      
      this.loadData().then(q=>this.init(this.collapse_query(q)))
        
    }
    loadData() {
        let productSubQuery = `
        ... on Product {
            title
            tags
            handle
            id
            description: metafield(namespace:"custom",key:"short_description") {
              value
            }
            length: metafield(namespace:"cnr",key:"total_length_mm") {
              __typename
              value
            }
            subtype: metafield(namespace:"cnr",key:"subtype") {
              value
            }
            incompatibleWith: metafield(namespace:"cnr",key:"builder_incompatibie") {
              value
              references(first:10) {
                nodes {
                  ... on Product {
                    id
                  }
                  
                }
              }
            }
            fastener: metafield(namespace:"cnr",key:"fastener") {
              reference {
                ... on Product {
                  count: metafield(namespace:"cnr",key:"item_count_per") {
                    value
                  }
                  title
                  tags
                  handle
                  id
                  variant: variants(first:1) {
                    nodes {
                      id
                      title
                      availableForSale
                      
                      price {
                        amount
                      }
                    }
                  }
                  featuredImage {
                    id
                    alt: altText
                    url
                  }
                }
              }
            }
            variant: variants(first:10) {
                nodes {
                    
                    id
                    title
                    availableForSale
                    
                    price {
                      amount
                    }
                    image {
                      id
                      alt: altText
                      url
                    }
                    length: metafield(namespace:"cnr",key:"length") {
                      __typename
                      value
                    }
                }
            }
            featuredImage {
              id
              alt: altText
              url
            }
        }
        `
        let fileSubquery = `
          ... on MediaImage {
            image {
              url
            }
          }
          `
     
        return this.graphql(
            `
            query getConfigObject($input:MetaobjectHandleInput!) {
                config: metaobject(handle:$input) {
                    id
                    handle
                    name: field(key:"name") {
                        value
                    }
                    segmentLength: field(key:"segment_length_cm") {
                        value
                    }
                    snapTo: field(key:"snap_to_length_cm") {
                        value
                    }
                    instructions: field(key:"instructions") {
                      references(first:10) {
                        nodes {
                          ... on Metaobject {
                            name: field(key:"name") {
                                value
                              }
                              title: field(key:"header_text") {
                                value
                              }
                              content: field(key:"instructions") {
                                value
                              }
                              video: field(key:"video") {
                                reference {
                                  ... on Video {
                                    sources {
                                      url
                                      type: mimeType
                                    }
                                  }
                                }
                              }
                              titleCard: field(key:"title_card") {
                                reference {
                                  ${fileSubquery}
                                }
                                
                              }
                          }
                        }
                      }
                    }
                    variables: field(key:"text") {
                      references(first:50) {
                        nodes {
                          ... on Metaobject {
                            key: field(key:"key") {
                              value
                            }
                            text: field(key:"value") {
                              value
                            }
                          }
                          
                        }
                      }
                    }
                    assets: field(key:"assets") {
                        references(first:20) {
                            nodes {
                              ... on Metaobject {
                              name: field(key:"name") {
                                value
                              }
                              key: field(key:"key") {
                                value
                              }
                              color: field(key:"color") {
                                value
                              }
                              showInLegend: field(key:"show_in_legend") {
                                value
                              }
                              image: field(key:"file") {
                                reference {
                                  ${fileSubquery}
                                }
                              }
                              
                              description: field(key:"description") {
                                value
                              }
                            }
                          }
                        }
                        
                        products: references(first:10) {
                            nodes {
                                ${productSubQuery}
                            }
                        }
                    }
                    options: field(key:"panel_type") {
                        references(first:10) {
                          nodes {
                              ... on Metaobject {
                                  name: field(key:"name") {
                                      value
                                  }
                                  postsPerSegment: field(key:"posts_per_segment") {
                                      value
                                  }
                                  railCount: field(key:"rail_count") {
                                      value
                                  }
                                  panel: field(key:"panel") {

                                      product: reference {
                                          ${productSubQuery}
                                      }
                                  }
                                  gates: field(key:"gates") {
                                      
                                      products: references(first:10) {
                                          nodes {
                                              ${productSubQuery}
                                          }
                                      }
                                  }
                                  posts: field(key:"posts") {
                                      products: references(first:10) {
                                          nodes {
                                              ${productSubQuery}
                                          }
                                      }
                                  }
                                  caps: field(key:"caps") {
                                      products: references(first:10) {
                                          nodes {
                                              ${productSubQuery}
                                          }
                                      }
                                  }
                                  clips: field(key:"clips") {
                                      products: references(first:10) {
                                          nodes {
                                              ${productSubQuery}
                                          }
                                      }
                                  }
                                  clamps: field(key:"clamps") {
                                      products: references(first:10) {
                                          nodes {
                                              ${productSubQuery}
                                          }
                                      }
                                  }
                              }
                            }
                        }
                    }

                }
            }
            `,
            {
              "input":{
                handle:this.config.builderType,
                type:"fence_builder_configuration"}
            }
        )
    }
    render(screen=0) {
      super.render(screen);
      
      
    }
    addScreen(screen) {
        this.screens.push(screen)
    }
    init(q) {
        console.error(q)
        this.data = q.data.config;
        let iconsMapped = {};

        let appVariables = {}
        this.data.variables.forEach(node=>appVariables[node.key]=node.text)
        this.config.googleMapId = appVariables["google-maps-map-id"];
        
        CnrVariableStore.setValues(appVariables)

        this.data.gateLengths = {}
        this.assets = {}
        
        this.data.assets.forEach(asset=>{
          this.assets[asset.key] = {
            color: asset.color,
            description: asset.description,
            image:asset.image?asset.image.image.url:null,
            name:asset.name,
            showInLegend: asset.showInLegend && asset.showInLegend!="false"
          }
        })
        

        this.data.options.forEach(option=>{
          option.gates.products.forEach(gate=>{
            gate.variant.forEach(variant=>{
              if (variant.length) {
                this.data.gateLengths[parseInt(variant.length.value).toString()] = true
              }  
            })
          })
        })
      
        
        this.addScreen(
          new SevenPeaksFenceBuilderInitializationScreen(this,this.data,this.screens.length)
        )
        this.addScreen(
          new SpFenceBuilderRailScreen(this,this.data,this.data,this.screens.length)
        )
        
        this.render()
    }
    selectPanel(selectedPanel) {

      let panel = this.data.options.find(option=>option.panel.product.id==selectedPanel.id)
      this.selectedPanelType = panel;
      this.screens = this.screens.filter(screen=>screen.preserve());
      let startingScreen = this.screens.length;
      
      this.basket.clearGates()
      this.basket.getGeometry().sides.reduce(
        (a,b)=>a.concat(b.components.filter(component=>component.type=="gate").map(gate=>gate.width)),
        []
      ).forEach((gateWidth,index)=>{
        let productSet = [];
        let gateOptions = []
        
        panel["gates"].products.forEach(gateProduct=>{
          gateProduct.variant.filter(gate=>parseInt(gate.length.value)==parseInt(gateWidth)).forEach(gate=>gateOptions.push(gate))
        })
        if (gateOptions.length==1) {
          let selectedVariant = gateOptions[0];
          let selectedProduct = panel["gates"].products.reduce((a,b)=>b.variant.find(variant=>variant.id==selectedVariant.id)?b:null,{})
          this.basket.setGate(index,{
              id:this.getId(selectedVariant),
              variant: selectedVariant,
              product: selectedProduct,
              quantity: this.multiplier("gate"),
              screen:null,
              label:"Gate"
          }); 
        } else {
          this.addScreen(
            new SpFenceBuilderGateScreen(
                this,
                {
                  type:"gates",
                  products:panel["gates"].products,
                  gateIndex:index,
                  gateLength:gateWidth
                },
                this.screens.length
              )
            )  
          }
      });

      
      
      let screenIndices = {};
      ["posts","caps","clips","clamps"].forEach(category=>{
        if (panel[category]) {
          screenIndices[category] = this.screens.length;
          this.addScreen(
            new SpFenceBuilderProductScreen(
              this,
              {
                type:category,
                products:panel[category].products
              },
              this.screens.length
            )
          )  
        }
      })
      this.addScreen(
        new SpFenceBuilderLastScreen(
          this,
          {},
          this.screens.length
        )
      )
      let existingClips = this.basket.getSection("clips");
     
      if (existingClips && existingClips.length>0) {
        let selectedClip = existingClips[0];
        selectedClip.quantity = this.multiplier("clips",selectedClip.product);
        selectedClip.recommended = selectedClip.quantity;
        selectedClip.screen = screenIndices["clips"]
        this.basket.setSection("clips",[selectedClip])
        
        let fastener = selectedClip.product.fastener;
        if (!selectedClip.hiddenItem) {
          this.basket.setSection("screws",[
                {
                  id:this.getId(fastener.variant[0]),
                  variant:fastener.variant[0],
                  "product":fastener,
                  "quantity":this.multiplier("screws",fastener),
                  recommended:this.multiplier("screws",fastener),
                  screen:null
              }
          ])
        }
      } else {
        this.basket.setSection("screws",[])
      }
      
      if (this.basket.isComplete()) {
        this.show(this.screens.length-1)    
      } else {
        this.show(startingScreen)  
      }
      
    }
    render(startingScreen=0) {
        super.render();
        this.setupEvents();
        CnR.dispatchEvent(
          "sorcistino:rendered",
          this
        )
        this.show(startingScreen)
    }
    
    renderFooter() {
        return ``
    }
    renderHeader() {
      return ``
    }
    renderProgressBar() {
        return `plop`
    }
    processScreen(data) {
      
    }
    reRenderBasket() {
      document.querySelector(".screen-summary .basket").innerHTML = this.basket.render()
    }
    renderProgressDetails() {
      
      return `
        ${this.renderStatistics(this.basket.basketIndex)}
        <div class="basket basket-display" data-basket="${this.basket.basketIndex}">
          ${this.basket.render()}
        </div>
      `
    }
    renderBasket() {
      return this.basket.render()
    }
    renderStatistics(basketIndex) {
      let previewImage = this.basket.get(basketIndex).geometry.staticMapUrl;
      let imagePreviewDiv = ``
      if (previewImage) {
        imagePreviewDiv = `
          <div class="preview-image">
            <img src="${previewImage}">
          </div>
        `
      }
      return `
      <div class="statistics">
          <div class="statistics-row">
            <div>Linear Footage:</div>
            <div class="fence-builder-linear-feet">${this.squareFeet(basketIndex)} ft</div>
          </div>
          <div class="statistics-row">
            <div>Number of Sides:</div>
            <div class="fence-builder-corner-count">${this.cornerCount(basketIndex)}</div>
          </div>
          <div class="statistics-row">
            <div>Gates:</div>
            <div class="fence-builder-gate-count">${this.gateCount(basketIndex)}</div>
          </div>
          ${imagePreviewDiv}
        </div>
      `
    }
  updateGeometry(data) {
      this.basket.setGeometry(data)
      this.geometryData = data;
      this.element(".fence-builder-linear-feet").innerHTML = this.squareFeet();
      this.element(".fence-builder-corner-count").innerHTML = this.cornerCount();
      this.element(".fence-builder-gate-count").innerHTML = this.gateCount();
  }
  updateProductQuantity(dataSet) {
      let basketIndex = parseInt(dataSet.basket)
      let basketDisplay = document.querySelector(`.basket-display[data-basket="${basketIndex}"]`)
      
      let totalField = basketDisplay.querySelector(".cart-total");
      let quantity = parseInt(dataSet.quantity);
      let recommended = parseInt(dataSet.recommended)
      let recText = "recommended";
      this.basket.updateQuantity(basketIndex,dataSet.productid,quantity)
      if (quantity<recommended) {
        recText = "less than recommended"
      } else if (quantity>recommended) {
        recText = "more than recommended"
      }
      basketDisplay.querySelector(`[data-product="${dataSet.productid}"] .quantity-label`).textContent = recText;
      if (totalField) {
        totalField.textContent = this.basket.total(basketIndex);  
      }
  }

  variantImage(product,variant) {  
    if (variant.image) {
      return variant.image.url.split("?")[0];
    }
    return product.featuredImage.url.split("?")[0]
  }
  variantImageAlt(product,variant) {
    if (variant.image) {
      return variant.image.alt;
    }
    return product.featuredImage.alt
  }
    
    
  nextBehaviour() {
    return "nextCompletes"
  }
  cornerCount(basketIndex) {
    return this.basket.getGeometry(basketIndex).sides.length;
  }
  polygonArea(vertices) {
      let area = 0;
      let n = vertices.length;

      for (let i = 0; i < n; i++) {
        let x1 = vertices[i].x;
        let y1 = vertices[i].y;
        let x2 = vertices[(i + 1) % n].x;
        let y2 = vertices[(i + 1) % n].y;
  
        area += (x1 * y2 - x2 * y1);
      }
      return Math.abs(area) / 2;
  }
  squareFeet(basketIndex) {
    let linearFeet = 0;
    let panels = this.basket.getSection("panels",basketIndex)
    if (panels) {
        linearFeet = panels[0].quantity*Math.round(parseInt(this.data.segmentLength.value)*0.0328);
      }
      if (linearFeet==0) {
        linearFeet = Math.round(this.geometry(basketIndex).sides.reduce(
          (a,b)=>a+b.components.filter(component=>component.type=="panel").reduce(
            (c,d)=>c+d.width,
            0
          ),
          0
        ))  
      }
      return linearFeet;
    }
    geometry(basketIndex) {
      return JSON.parse(JSON.stringify(this.basket.getGeometry(basketIndex)))
    }
    panelCount(basketIndex) {
      let panels = this.basket.getSection("panels",basketIndex);
      if (panels) {
        return panels[0].quantity;  
      }
      return Math.ceil(this.squareFeet(basketIndex)/20)
    }
    gateCount(basketIndex) { 
      return Math.ceil(this.basket.get(basketIndex).geometry.sides.reduce(
        (a,b)=>a+b.components.filter(component=>component.type=="gate").reduce(
            (a1,b1)=>a1+b1.count,
            0
          ),
        0
      ))
    }
  
    multiplier(type,product) {
      let railCount = this.selectedPanelType?parseInt(this.selectedPanelType.railCount):0;
      
      let clipCount = (postCount) => ((postCount*railCount)%10>0) ? (postCount*railCount)+(10-(postCount*railCount)%10) : postCount*railCount;
      let sideCount = this.geometry().sides.length;
      let panelMultiplier = (this.panelCount()*2)+1;
      switch(type) {
        case "panels":
            
          return this.panelCount()
          break;
        case "posts":
        case "caps":
            return panelMultiplier
            break;
        case "clips":
            return (panelMultiplier*railCount)+(railCount*sideCount)
            return clipCount(panelMultiplier,parseInt(this.selectedPanelType.railCount))+(parseInt(this.selectedPanelType.railCount)*this.geometry().sides.length)
            break;
        case "screws":
          let countPer = parseInt(product.count.value)
          return Math.ceil(
            (((panelMultiplier*railCount)+(railCount*sideCount))*2)/countPer
          )
          default:
            return 1
            break;
        case "bolts":
          return Math.ceil(
            (((panelMultiplier*railCount)+(railCount*sideCount))*2)/50
          )
      }
    }
    getId(object) {
      return object.id.split("/").pop()
    }
    
    processScreen(data) {
      
      switch(data.section) {
        case "geometry":
          this.geometryData = data.geometry;
          this.basket.clear()
          this.basket.setGeometry(data.geometry)
          this.next()
          break;
        case "panels":
          this.basket.setSection("panels",[
            {
              id:this.getId(data.selectedVariant),
              variant: data.selectedVariant,
              product:data.selectedProduct,
              quantity: this.multiplier("panels"),
              screen:this.screen,
              recommended:this.multiplier("panels"),
              label:"Fence"
            }
          ])
          
          this.selectPanel(data.selectedProduct)
          break;
        case "clear":
          this.basket.clearSection(data.type)
          this.next();
          break;
        case "options":
          this.basket.setSection(data.type,[{
            id:this.getId(data.selectedVariant),
            variant:data.selectedVariant,
            product: data.selectedProduct,
            quantity: this.multiplier(data.type,data.selectedProduct),
            recommended: this.multiplier(data.type,data.selectedProduct),
            label:`${data.type.depluralize().capitalize()}`,
            screen:this.screen,
            hiddenItem:data.hiddenItem?true:false
          }])
          
          if (data.type=="clips" && !data.hiddenItem) {
              let fastener = data.selectedProduct.fastener;
              this.basket.setSection("screws",[
                {
                  id:this.getId(fastener.variant[0]),
                  variant:fastener.variant[0],
                  "product":fastener,
                  "quantity":this.multiplier("screws",fastener),
                  recommended:this.multiplier("screws",fastener),
                  screen:null,
                  hiddenItem:false,
                  
                }
              ])
          } else {
            this.basket.setSection("screws",[])
          }
          if (this.basket.isComplete()) {
            this.show(this.screens.length-1)
          } else {
            this.next()  
          }
          
          break;
        case "gates":
          this.basket.setGate(
            data.gateIndex,
            {
              id:this.getId(data.selectedVariant),
              variant: data.selectedVariant,
              product: data.selectedProduct,
              quantity: this.multiplier(data.type,data.selectedProduct),
              screen:this.screen,
              label:"Gate"
            }
          )
          this.next();
      }
    }
    show(screen) {
      super.show(screen);
      if (CnR.isMobile()) {
        document.querySelector(".announcement-bar-section").scrollIntoView(true)
      }
    }
    doAtc() {
      let payload = this.basket.payload()
      this.basket.addToCart().then(cart=>{
        location.href = '/cart/'
      })
    }
    renderPreNav() {
      if (!CnR.isMobile()) {
        return '';
      }
      return `
        <div class="mobile-summary border-top">
          <label for="preview-summary" class="sorcistino-nav-button cta grid-item-cta cta-foreward-lite-primary preview-summary-button">
            <input type="checkbox" id="preview-summary" name="preview-summary" class="preview-summary">
            Project Summary
          </label>  
          <div class="project-summary">
              ${this.renderProgressDetails()}
          </div>
        </div>
      `
    }
    compatibilityFilter(productList) {
      // generate all products
      let basketProducts = []
      Object.values(this.basket.contents()).forEach(segment=>segment.forEach(entry=>basketProducts.push(entry.product.id)));
      let filteredProducts =[];
      productList.forEach(product=>{
        if (product.incompatibleWith) {
            let compatible = product.incompatibleWith.reduce((a,b)=>a && !basketProducts.includes(b.id),true);
            if (!compatible) {
              
            } else {
              filteredProducts.push(product)
            }
        } else {
          filteredProducts.push(product)
        }
      })
      return filteredProducts;
    }
    
}

class SpFenceBuilderScreen extends SorcistinoScreen {
    title() {
      return `Screen ${this.index+1}`
    }
    autoadvance() { return true;}
        
    render() {
        this.parent.setContent(`
        <div class="builder-header" style="background-image:url(${this.parent.data.assets.find(asset=>asset.key=="header-background").image.image.url})">
          <h1>Build a Fence</h1>
        </div>
        <div class="panels fence-builder" data-uuid="${this.uuid}">
            
            <div class="screen-content">
                <h3>${this.title()}</h3>
                ${this.renderContent()}
                
                ${this.parent.renderNavButtons()}
            </div>
            <div class="screen-summary">
                <div class="summary-header">
                    <h3>Project Summary</h3>
                </div>
                ${CnR.isMobile()?'':this.parent.renderProgressDetails()}
            </div>
        </div>
        `);
        this.setupEvents()
        CnrQuantity.setupEvents()

      }
    renderContent() {
        return ``
    }
    setupEvents() {
      
      this.parent.setBackVisibility(this.index>0)
      this.element('[data-screen-nav="next"]').addEventListener("click",event=>this.complete())
      this.element('[data-screen-nav="back"]').addEventListener("click",event=>this.parent.prev())
    }
    hideBack() { return false;}
}

class SevenPeaksFenceBuilderInitializationScreen extends SpFenceBuilderScreen {
  
  
  constructor(parent,data,index) {
    super(parent,data,index);
    
    this.initialized  = false;
    this.savedState = null;
    this.linearFeet = null;
    this.sides = null;
    this.gates = null;
    this.selectedGates = [];
    if (CnR.isMobile()) {
      this.mode = "basic"  
    } else {
      this.mode = "advanced"
    }
    

    this.sidesSelector = new CnrSelect(
      {
        "name":"cnr-corner-selector",
        "id":"corner-selector",
        "options":[
          {label:"1",value:"1"},
          {label:"2",value:"2"},
          {label:"3",value:"3"},
          {label:"4",value:"4"},
          {label:"5",value:"5"},
          {label:"6",value:"6"},
          {label:"7",value:"7"},
          {label:"8",value:"8"},
          {label:"9",value:"9"},
          {label:"10",value:"10"},
        ],
        value:this.sides,
      }
    );
    this.gateSelector = new CnrSelect(
      {
        "name":"cnr-gate-selector",
        "id":"gate-selector",
        "options":[
          {label:"None",value:"0"},
          {label:"1",value:"1"},
          {label:"2",value:"2"},
          {label:"3",value:"3"},
          {label:"4",value:"4"},
          {label:"5",value:"5"},
          {label:"6",value:"6"},
          {label:"7",value:"7"},
          {label:"8",value:"8"},
        ],
        value:this.gates
      }
    )
    
    document.addEventListener("cnr:mapdrawer:finished",event=>{
      this.saveState();
      this.parent.basket.unComplete()
      this.broadcastCompletion({section:"geometry",type:"geometry",geometry:event.detail})
    })
    document.addEventListener("cnr:mapdrawer:setMode",event=>{
      this.setMode(event.detail)
    })
    document.addEventListener("cnr:map:geometry:set",event=>{
      let geometry = event.detail;
      this.setMode(geometry.mode)
      
    })
    document.addEventListener("cnr:map:geometry:reset",event=>{
      let geometry = event.detail;
      this.setMode(geometry.mode)
      
    })
  }
  setMode(mode) {
    
    this.mode = mode;
      
    this.parent.setNextVisibility(this.mode=="basic")
    this.root().querySelectorAll(".entry-option").forEach(node=>{
      if (node.classList.contains(this.mode)) {
        node.classList.add("active");
      } else {
        node.classList.remove("active")
      }
    })
    switch(this.mode) {
      case "basic":
        this.element(".screen-summary").style.display="none";
        break;
      case "advanced":
        this.element(".screen-summary").style.display="flex";
        break;
    }
    let drawingDiv = this.element(".google-map-holder");
    if (drawingDiv.querySelector(".google-map")==null) {
      this.mapElement = new SevenPeaksInteractiveMap({googleMapId:this.parent.config.googleMapId,config:this.data})
    }
  }
  saveState() {
    
    this.savedState = [];
    
    
    
    Array.from(this.element(".screen-content").children).forEach(node=>{
      this.savedState.push(node)
      node.parentNode.removeChild(node)
    });
    this.element(".screen-content").innerHTML = '';
  }
  restoreState() {
    
    let existingNodes = []
    let screenContent = this.element(".screen-content");
    Array.from(screenContent.children).forEach(node=>{
      screenContent.removeChild(node)
    })
    
    this.savedState.forEach(node=>screenContent.appendChild(node));
    existingNodes.forEach(node=>screenContent.appendChild(node));
    
    CnR.dispatchEvent(
          "cnr:map:geometry:set",
          this.parent.basket.get().geometry
        )
    
  }
  
  render() {
    
    this.parent.setContent(`
        <div class="builder-header" style="background-image:url(${this.data.assets.find(asset=>asset.key=="header-background").image.image.url})">
          <h1>Build a Fence</h1>
        </div>
        <div class="panels fence-builder calculator-screen" data-uuid="${this.uuid}">
            
            <div class="screen-content">
                
                ${this.savedState?'':this.renderContent()}
                ${this.parent.renderNavButtons()}
            </div>
            <div class="screen-summary">
                <div class="summary-header">
                    <h3>Project Summary</h3>
                </div>
                ${this.parent.renderProgressDetails()}
            </div>
        </div>
        `);
        
      this.parent.setNextVisibility(true);
      if (this.element(".mobile-summary")) {
        this.element(".mobile-summary").classList.add("hide");  
      }
      this.setupEvents()
      
      
  }
  
 
  renderContent() {
   
    if (this.savedState) {
      return '';
    }
    
   
    return `
      <div class="basic-entry-mode entry-option basic ${this.mode=="basic"?" active":""}">
        <div class="manual-builder">
          <div class="form">
            <div class="form-row">
               <div class="field-label">
                  ${CnrVariableStore.textFor('linear-feet-label')}
               </div>
               <div class="field-value">
                  <input type="text" name="linear-feet" class="linear-feet" value="${this.linearFeet||""}" placeholder="Linear Feet">
               </div>
            </div>
            <div class="form-row">
               <div class="field-label">
                  ${CnrVariableStore.textFor('side-count-label')}
               </div>
               <div class="field-value corners">
                  ${this.sidesSelector.render()}
               </div>
            </div>
            <div class="form-row">
               <div class="field-label">
                  ${CnrVariableStore.textFor('gate-count-label')}
               </div>
               <div class="field-value gates-selector">
                  ${this.gateSelector.render()}
               </div>
               <div class="gate-selector-options"></div>
            </div>
           </div>
          <div class="illustration"><img src="${this.data.assets.find(asset=>asset.key=="fence_diagram").image.image.url}"></div>
        </div>
      </div>
      <div class="google-map-holder entry-option advanced ${this.mode=="advanced"?" active":""}"></div>
    `

  }
  extraButtons() {
    return `
      <button class="button cta grid-item-cta cta-foreward-lite-primary advanced-mode">
        ${CnrVariableStore.textFor("switch-from-basic")}
      </button>
    `;
  }
  setupEvents() {
    
    
    super.setupEvents()
    
    if (this.savedState) {
      this.restoreState();
      return;
    }
    let gateDropDown = document.querySelector("#gate-selector")
      gateDropDown.addEventListener("change",event=>{
        this.gates = parseInt(gateDropDown.options[gateDropDown.selectedIndex].value);
        this.gateSelector.setValue(this.gates);
        this.renderGateSelectors()
    })
    let linearFeetField = this.element(".linear-feet")
    linearFeetField.addEventListener("keydown",event=>{
      if (parseInt(linearFeetField.value)>0) {
        this.parent.setNextVisibility(true)
      }
    })
    linearFeetField.addEventListener("change",event=>{
      if (parseInt(linearFeetField.value)>0) {
        this.parent.setNextVisibility(true)
      }
    })
    let sideSelector = this.element("#corner-selector");
    if (sideSelector) {
      sideSelector.addEventListener("change",event=>{
        this.sides = parseInt(sideSelector.options[sideSelector.selectedIndex].value)
        this.sidesSelector.setValue(this.sides)
      })
    }
    this.addListener(".advanced-mode","click",(event)=>{
      this.setMode("advanced")
    })
    this.renderGateSelectors()
    if (this.events) {
      return;
    }
    
    this.events = true;
    
    
    
    
      this.mapElement = new SevenPeaksInteractiveMap({googleMapId:this.parent.config.googleMapId,config:this.data})
      
    if (this.mode=="basic") {
      this.parent.setNextVisibility(true);
    }
    this.element(".linear-feet").addEventListener("keyup",event=>{
      let value = parseInt(event.target.value);
      if (value && value>0) {
        this.parent.setNextVisibility(true)
      } else {
        this.parent.setNextVisibility(false)
      }
    })
    CnR.dispatchEvent("cnr:formFields:rendered")
    
  }
  renderGateSelectors() {
    
    let gateCountSelector = this.root().querySelector("#gate-selector");
    let gateCount = parseInt(this.gateSelector.value);
    let gateSelectorOptions = this.root().querySelector(".gate-selector-options")
    this.root().querySelectorAll(".gate-length-select").forEach((gate,index)=>{
      this.selectedGates[index] = parseInt(gate.options[gate.selectedIndex].value)
    })
    gateSelectorOptions.innerHTML = '';

    
    
    let gateLengths = Object.keys(this.parent.data.gateLengths).map(option=>parseInt(option));
  
    for (let i=0;i<gateCount;i++) {
      if (this.selectedGates[i]==null) {
        this.selectedGates[i] = gateLengths[0];
      }
      let gateSelector = `
        <div class="selectorItem">
          <div class="slector-value" data-index="${i}"><select name="selector-${i}" class="gate-length-select" data-index="${i}">
            ${gateLengths.map(width=>`
              <option value="${width}" ${this.selectedGates[i]==width?' selected':''}>${width}'</option>`).join('\n')
            }
            </select>
        </div>
      `
      gateSelectorOptions.innerHTML+=gateSelector;
    }
    this.root().querySelectorAll(".gate-length-select").forEach(selector=>selector.addEventListener("change",event=>{
        let value = parseInt(selector.options[selector.selectedIndex].value)
        this.selectedGates[parseInt(selector.dataset.index)] = value;
      })
    )
    
  }
  complete() {
    if (this.mode=="advanced") {
      this.parent.next();
      return;
    }
    let data = {
      length: parseInt(this.element(".linear-feet").value),
      sideCount: parseInt(this.sidesSelector.getValue()),
      gateCount: parseInt(this.gateSelector.getValue())
    }

    
    
    this.linearFeet = data.length;
    this.sides = data.sideCount;
    this.gates = data.dateCount;
    let lengthPerSide = data.length/data.sideCount;
    let gatesAvailable = data.gateCount;
    let geometry = {
      "sides":[],
      "mode":"basic",
    }
    for (let i=0;i<data.sideCount;i++) {
      let side = 
        {
          components:[
            {
              type:"panel",
              count:Math.round((lengthPerSide/20)*10)/10,
              width:lengthPerSide
            }
          ]
        }
      geometry.sides.push(side);
    }
    this.root().querySelectorAll(".gate-length-select").forEach(selector=>{
          geometry.sides[0].components.push(
            {
              type:"gate",
              count:1,
              width:parseInt(selector.options[selector.selectedIndex].value)
            }
          )
          gatesAvailable = 0;
        });
    
    this.broadcastCompletion({section:"geometry",type:"geometry",geometry:geometry})
    this.element(".summary-header").style.display="flex";
  }
  title() {
    return "Create Your Fence";
  }
  preserve() {
    return true;
  }
  
}

class SpFenceBuilderProductScreen extends SpFenceBuilderScreen {
  title() {
    return `Choose Your ${this.data.type}`
  }
  selector() {
    return "radio"
  }
  constructor(parent,data,index) {
    super(parent,data,index);
    this.selectedOption = null;
  }
  getId(object) {
    return object.id.split("/").pop()
  }
  unComplete() {
    super.unComplete();
    this.selectedOption = null;
    
  }
  variantImage(product,variant) {
    return this.parent.variantImage(product,variant)  
  }
  variantImageAlt(product,variant) {
    return this.parent.variantImageAlt(product,variant)
  }
  
  filteredVariants(variants) {
    return variants;
  }
  
  productRow(product,selectedVariantId) {
      
      let productId =  this.getId(product)

      let infoIcon = (product,variant)=>{
        
        if (product.description) {
          let variantId = variant.id.split("/").pop()
          return `
            <div class="product-info">
              <div class="icon" data-variant="${variantId}">
                <img src="${this.parent.assets['info-icon'].image}">
              </div>
              <div class="info" data-variant="${variantId}">${product.description.value.split("\n").map(p=>`<p>${p}</p>`).join("")}</div>
              </div>
          `
        } else {
          return ``
        }
      };

      return this.filteredVariants(product.variant).map(variant=>`
        <div class="item-entry">
          <label for="product-${this.getId(variant)}" class="product-selection-row">
            <input type="${this.selector()}" class="product-selector-radio" name="product-${this.uuid}" id="product-${this.getId(variant)}" value="${this.getId(variant)}" ${this.getId(variant)==selectedVariantId?' checked':''}>
            <div class="product-image"><img src="${this.variantImage(product,variant)}?width=105&height=93&crop=center" alt="${this.variantImageAlt(product,variant)}"></div>
            <div class="product-title">${product.title} ${variant.title.includes("Default")?'':variant.title}</div>
            ${infoIcon(product,variant)}
          </label>
        </div>
      `).join("\n")
      
    }
  productList() {
    return this.parent.compatibilityFilter(this.data.products);
    //return this.data.products;
  }
  renderContent() {
    
    return `<div class="listing">${this.productList().map(product=>this.productRow(product,this.selectedOption,"radio")).join("")}</div>`
  }
  setupEvents() {
    super.setupEvents()
    this.parent.setNextVisibility(this.selectedOption!=null)
    
    
    this.root().querySelectorAll(".product-selector-radio").forEach(radio=>radio.addEventListener('click',event=>{
     
      this.selectedOption = radio.value;
      this.parent.setNextVisibility(true)
      if (this.autoadvance()) { this.complete()}
    }))
    if (CnR.isMobile()) {
      this.root().querySelectorAll(".product-info .icon").forEach(icon=>{
        icon.addEventListener("click",event=>{
          event.preventDefault();
          event.stopPropagation();
          let infoHTML = this.element(`.info[data-variant="${icon.dataset.variant}"]`)
          if (infoHTML) {
            let modal = CnRModal.show(infoHTML.innerHTML);
            modal.classList.add("info-popup")
            modal.querySelector(".modal-content").addEventListener("click",event=>CnRModal.close())
          }
        })
      })  
    }
    
  }
  preserve() {
    return false
  }
  section() {
    return "options"
  }
  completionPayload() {
    let selectedProduct = null;
    let selectedVariant = null;
    this.productList().forEach(product=>{
      
      product.variant.forEach(variant=>{
      
        if (this.getId(variant)==this.selectedOption) {
          selectedProduct = product;
          selectedVariant = variant
        }
      })
    })
    if (selectedVariant) {
      if (selectedProduct.tags.includes("do-not-add")) {
        return {
          section:this.section(),
          type:this.data.type,
          selectedProduct:selectedProduct,
          selectedVariant:selectedVariant,
          screenIndex:this.index,
          hiddenItem:true
        }
      }
      return {
        section:this.section(),
        type:this.data.type,
        selectedProduct:selectedProduct,
        selectedVariant:selectedVariant,
        screenIndex:this.index,
        hiddenItem: false
      }
    }
    return null;
  }
  complete() {
    let payload = this.completionPayload()
    if (payload!=null) {
      this.broadcastCompletion(payload)
    }
  }
}

class SpFenceBuilderGateScreen extends SpFenceBuilderProductScreen {
  title() {
    return `Choose Your Gate: #${this.data.gateIndex+1} (${this.data.gateLength}')`
  }
  section() {
    return "gates"
  }
  complete() {
    let payload = this.completionPayload()
    if (payload!=null) {
      payload.gateIndex = this.data.gateIndex
      this.broadcastCompletion(payload)
    }
  
  }
  filteredVariants(variants) {
    return variants.filter(variant=>variant.length && parseInt(variant.length.value)==parseInt(this.data.gateLength))
  }
}

class SpFenceBuilderRailScreen extends SpFenceBuilderProductScreen {
  title() {
    return CnrVariableStore.textFor("select-panels")
  }
  selector() { return "radio"; }
  constructor(parent,data,index) {
    super(parent,data,index);
    this.selectedOption = null;
  }
  preserve() {
    return true
  }
  section() { return "panels" }

  productList() {
    return this.data.options.map(option=>option.panel.product);
  }
}

class SpFenceBuilderDataCollectionScreen extends CnR {
  constructor(options) {
    super(options)
    let alreadyCollected = sessionStorage.getItem("data-gathered")
    if (alreadyCollected || !CnrVariableStore.booleanFor("data-collection-show-popup")) {
      return;
    }
    
    let modal = CnRModal.show(
      `
        <h3 class="data-collection-popup-header">${CnrVariableStore.textFor("data-collection-header")}</h3>
        <p class="data-collection-popup-subtitle">${CnrVariableStore.textFor("data-collection-subtitle")}</p>
        <form class="data-collection-form">
        <div class="data-collection-form-holder">
          <div class="collection-form-row">
            <div class="collection-form-label">
              ${CnrVariableStore.textFor("data-collection-name")}
            </div>
            <div class="collection-form-field">
              <input type="text" name="name" required>
            </div>
          </div>
          <div class="collection-form-row">
            <div class="collection-form-label">
              ${CnrVariableStore.textFor("data-collection-email")}
            </div>
            <div class="collection-form-field">
              <input type="email" name="email" required>
            </div>
          </div>
          <div class="collection-form-row">
            <div class="collection-form-label">
              ${CnrVariableStore.textFor("data-collection-phone")}
            </div>
            <div class="collection-form-field">
              <input type="tel" name="telephone">
            </div>
          </div>
          <div class="collection-form-buttons">
            <button class="button cta grid-item-cta cta-foreward-lite-primary skip" ${CnrVariableStore.booleanFor("data-collection-allow-skip")?'':'style="display:none"'}>
              ${CnrVariableStore.textFor("data-collection-skip-button")}
            </button>
            <button type="submit" class="button cta grid-item-cta cta-foreward-lite-primary send-data">
              ${CnrVariableStore.textFor("data-collection-continue-button")}
            </button>
          </div>
        </div>
        </form>
      `,
      false
    )
    modal.querySelector("button.skip").addEventListener("click",event=>{
      CnRModal.close();
    })
    if (CnR.isMobile()) {
      modal.style.top = "0px";  
    }
    
    modal.classList.add("data-collector")
    let collectionForm = modal.querySelector("form");
    collectionForm.addEventListener("submit",event=>{
      event.preventDefault();
      event.stopPropagation();
      let formData = new FormData(collectionForm);

      let submitButton = modal.querySelector(".send-data");
      submitButton.disabled = true;
      submitButton.textContent = CnrVariableStore.textFor("submitting-to-ghl")
     
      CnR.dispatchEvent(
        "ghl:data:submit",{
          email:formData.get("email"),
          name:formData.get("name"),
          telephone:formData.get("telephone"),
          baskets:this.config.baskets,
        })
    })
  }
}


  
class SpFenceBuilderLastScreen extends SpFenceBuilderScreen {
   constructor(parent,data,index) {
      super(parent,data,index);
     
     this.basketQuickChangeScreen = null
   }
  title() {
    return CnrVariableStore.textFor("review-fence")
  }
 
  hideBack() {
    return false
  }
  renderContent() {
      
      return `
       
        <div class="all-baskets">
          ${this.parent.basket.baskets.map((basket,index)=>`
            <div class="basket-entry-header" data-basket="${index}">${CnrVariableStore.textFor("quote-entry-header")} ${index+1}</div>
            <div class="final-basket basket-display" data-basket="${index}">
             <div class="final-summary">${this.parent.renderStatistics(index)}</div>
              <div class="items">
                ${this.parent.basket.render(index)}
              </div>
              <div class="final-actions">
                <div class="cart-total-atc">
                  <div class="cart-total-display">
                    Total <span class="cart-total" data-basket="${index}">${this.parent.basket.total(index)}</span>  
                  </div>
                  <div>
                    <button class="button atc" data-uuid="${this.parent.basket.baskets[index].id}" data-basket="${index}">
                      ${CnrVariableStore.textFor("add-to-cart")}
                    </button>
                  </div>
                </div>
                <div class="basket-buttons" ${CnR.isMobile()?'style="display:none"':''}>  
                  <button class="button edit" data-uuid="${this.parent.basket.baskets[index].id}" data-basket="${index}">
                    ${CnrVariableStore.textFor("summary-edit-fence-label")}
                  </button>
                   <button class="button clone" data-uuid="${this.parent.basket.baskets[index].id}" data-basket="${index}">
                    ${CnrVariableStore.textFor("summary-clone-fence-label")}
                  </button>
                  
                   <button class="button delete" data-uuid="${this.parent.basket.baskets[index].id}" data-basket="${index}">
                    ${CnrVariableStore.textFor("summary-delete-fence-label")}
                  </button>
                </div>
              </div>
            </div>
            `).join("")}
        </div>
      `;
    
  }
  extraButtons() {
    let retVal = ``;
    if (!CnR.isMobile()) {
      retVal+=`<button class="button add-quote">
        ${CnrVariableStore.textFor("add-quote-text")}
      </button>`;
      /*
      <button class="button save-quote">
        ${CnrVariableStore.textFor("save-quote-text")}
      </button>
      `*/
      
    }
    return retVal;
      
  }
  setupEvents() {
    super.setupEvents();
    
    if (this.parent.basket.count()<2) {
      this.root().querySelectorAll("button.delete").forEach(button=>button.style.display="none")
    }
    this.element("h3").classList.add("border-bottom")
    this.element(".screen-summary").classList.add("final")
    this.element(".screen-content").classList.add("final")
    if (this.element(".mobile-summary")) {
        this.element(".mobile-summary").classList.add("hide");  
      }
    this.root().querySelectorAll("button.atc").forEach(atc=>atc.addEventListener("click",event=>{
      let basketIndex = parseInt(event.target.dataset.basket)
      this.parent.basket
        .addToCart(basketIndex,{
          _opportunityId:this.parent.appBridge.opportunityId,
          _contactId:this.parent.appBridge.contactId
        })
        .then(cart=>{
          
          if (false) {
            CnRModal.show(`
            <h3>Error!</h3>
            ${CnrVariableStore.textFor('failed-cart-help')}
            `)
          }
          else {
            CnR.dispatchEvent("ghl:note:add",`Added Quote ${this.parent.basket.get(basketIndex).id} to cart`)      
          }
        
        
        CnR.openDawnCart()
      }).catch((e) => {
          console.error(e);
      });
      
    }))
    this.root().querySelectorAll("button.edit").forEach(
      button=>button.addEventListener("click",event=>{
        /*
        this.parent.basket.load(parseInt(button.dataset.basket))
        CnR.dispatchEvent(
          "cnr:map:geometry:set",
          this.parent.basket.get().geometry
        )
        */
        CnR.dispatchEvent("cnr:fence-builder:edit-fence",button.dataset.basket)
                                      
      })
    )
    
    this.root().querySelectorAll("button.clone").forEach(
      button=>button.addEventListener("click",event=>{
        let basketIndex = parseInt(button.dataset.basket)
        this.parent.basket.clone(basketIndex);
        this.render()
      })
    )
    this.root().querySelectorAll("button.delete").forEach(button=>button.addEventListener("click",event=>{
        this.parent.basket.delete(parseInt(button.dataset.basket))
        this.parent.show(this.index)
        
      })
    )
    
    this.root().querySelectorAll(".change-item").forEach(changer=>changer.addEventListener("click",event=>{
      let basket = parseInt(changer.dataset.basket)
      let screen = parseInt(changer.dataset.screen)
      this.basketQuickChangeScreen = screen;
      

      this.parent.basket.load(basket)
      this.parent.show(screen)
      
    }))
    this.addListener("button.add-quote","click",(event)=>{
      CnR.dispatchEvent(
        "cnr:fence-builder:add-quote"
      )})
      let targetBasket = document.querySelector(`.basket-entry-header[data-basket="${this.parent.basket.basketIndex}"]`);
      if (this.parent.basket.count()>0 && this.parent.basket.basketIndex>0) {
        window.setTimeout(()=>{
            
            targetBasket.scrollIntoView({behavior:"smooth","block":"center"});
            this.basketQuickChangeScreen = screen;
          },
          100
        )  
      }
      
      if (this.basketQuickChangeScreen!=null){
        let targetItem = document.querySelector(`.final-basket.basket-display[data-basket="${this.parent.basket.basketIndex}"]`)
          .querySelector(`[data-screen="${this.basketQuickChangeScreen}"]`);
        window.setTimeout(()=>{
            
            targetItem.scrollIntoView({behavior:"smooth","block":"start"});
            targetBasket.scrollIntoView({behavior:"smooth","block":"center"});
            this.basketQuickChangeScreen = null;
          },
          100
        )
      }
    
      this.addListener("button.save-quote","click",(event)=>{
        fetch(
          `${CnrVariableStore.textFor("custom-app-url")}saveQuote`,
          {
                method: 'POST',
                //credentials: 'include',
                headers: {
                    'Content-Type': 'application/json',
                },
                body:JSON.stringify({email:'fattycrabcakes@gmail.com',baskets:this.parent.basket.baskets,title:"Test Upload"})
            }
        ).then(response=>response.json()).then(response=>console.error(response))
      })

    if (!this.parent.appBridge.hasContact()) {
      const dataModal = new SpFenceBuilderDataCollectionScreen({baskets:this.parent.basket.baskets})  
    } 
    this.parent.setBackVisibility(false)
  }
 
  postRender() {
    this.parent.setBackVisibility(false)
    this.parent.basket.setComplete()
  }
  canGoBack() { return false;}
  
}


//# sourceMappingURL=/sm/e1ebbfe1bf0b0061f0726ebc83434e1c2f8308e6354c415fd05ecccdaad47617.map


/**
 * Currency Helpers
 * -----------------------------------------------------------------------------
 * A collection of useful functions that help with currency formatting
 *
 * Current contents
 * - formatMoney - Takes an amount in cents and returns it as a formatted dollar value.
 *
 */

(function () {
    const moneyFormat = '${{amount}}';
  
    /**
     * Format money values based on your shop currency settings
     * @param  {Number|string} cents - value in cents or dollar amount e.g. 300 cents
     * or 3.00 dollars
     * @param  {String} format - shop money_format setting
     * @return {String} value - formatted value
     */
    var formatMoney = function(cents, format) {
      if (typeof cents === 'string') {
        cents = cents.replace('.', '');
      }
      let value = '';
      const placeholderRegex = /\{\{\s*(\w+)\s*\}\}/;
      const formatString = format || moneyFormat;
  
      function formatWithDelimiters(
        number,
        precision = 2,
        thousands = ',',
        decimal = '.'
      ) {
        if (isNaN(number) || number == null) {
          return 0;
        }
  
        number = (number / 100.0).toFixed(precision);
  
        const parts = number.split('.');
        const dollarsAmount = parts[0].replace(
          /(\d)(?=(\d\d\d)+(?!\d))/g,
          `$1${thousands}`
        );
        const centsAmount = parts[1] ? decimal + parts[1] : '';
  
        return dollarsAmount + centsAmount;
      }
  
      switch (formatString.match(placeholderRegex)[1]) {
        case 'amount':
          value = formatWithDelimiters(cents, 2);
          break;
        case 'amount_no_decimals':
          value = formatWithDelimiters(cents, 0);
          break;
        case 'amount_with_comma_separator':
          value = formatWithDelimiters(cents, 2, '.', ',');
          break;
        case 'amount_no_decimals_with_comma_separator':
          value = formatWithDelimiters(cents, 0, '.', ',');
          break;
      }
  
      return formatString.replace(placeholderRegex, value);
    }
  
    window.formatMoney = formatMoney;
  })()

/* Smooth scroll button anchor links */
document.querySelectorAll('.button-group-anchor').forEach(button => {
    button.addEventListener('click', function(event) {
        event.preventDefault();
        const href = this.getAttribute('href');

        if (href && href.startsWith('#')) {
            const targetId = href.substring(1);
            const targetElement = document.getElementById(targetId);

            if (targetElement) {
                targetElement.scrollIntoView({
                    behavior: 'smooth',
                    block: 'start'
                });
            }
        }
    });
});